window.refreshOrderDetailV2 = function() {
    ReportSharedFunctions.InitReportPage();

    if (!Model.Validated)
        window.addLocks(new URLSearchParams(window.location.search).get('fc') * 1, orderDetailLockUIDs);

    ReportSharedFunctions.ShowUnknownWordsFoundMessageIfThereAreAny(Model.AmountOfWordsToReviewForUser);

    function ResizeOrderReportFields(e) {
        $('div#subPageContent').height($('div#content').height() - 20 - $('div#submitBottom').height());

        var maxHeight = $('#subPageContent').height() - ($('#breadcrumb').height() + $('#subPageContent h2').height() + 40);
        $('.leftReportHolder, .tabsReportHolder, .reportReportHolder').css('height', maxHeight);
        $('#orderReportWrapper').css('height', maxHeight - $('#proceduresInReporContainer').height() - 22);
        $('#validatedTab').css('height', maxHeight - $('#proceduresInReporContainer').height() - 22);
        //$('#screening').css('height', maxHeight - $('#proceduresInReporContainer').height() - 22);
        $('#previousReportContainerInTab').css('height', maxHeight - 93 - $('#historyTabPreviousReport ul.procedures').height() - 12 - $('#historyTabPreviousReport #previousReportInfoInTab').height() - 36);
    }

    if(bulkDictation)
    {
        $('#loading').hide();

        let skipToOrder_UID;
        let goToOtherOrderInBulkResource;

        if (dictatedBy == null || dictatedBy == '') {
            goToOtherOrderInBulkResource = window.Resources.GoToOtherOrderInBulk;
        } else {
            goToOtherOrderInBulkResource = window.Resources.GoToOtherOrderInBulkValidation;
        }

        $('#confirmSkipToOtherBulkReport').dialog({
            autoOpen: false,
            resizable: false,
            modal: true,
            appendTo: '#contentView',
            position: { my: "right top", at: "right-15 top+30", of: '#contentView' },
            title: htmlDecode(goToOtherOrderInBulkResource)
        });

        $.each($('.transformToCalendar'), function (i, y) {
            var m = moment($(y).text(), "MM/DD/YYYY hh:mm:ss A");
            if (m != null && m.isValid) {
                $(y).text(htmlDecode(m.calendar()));
            }
        });

        $('tr.orderInActiveBulk').on('dblclick', function (e) {
            e.stopImmediatePropagation();
            e.stopPropagation();

            if (!$(this).hasClass('currentActiveBulk') && $(this).find('td.doneBulkReport').length == 0) {
                skipToOrder_UID = $(this).find('.bulkDictationOrder_UID').val();

                $('#confirmSkipToOtherBulkReportHolder').empty();

                var cloneBulkOrderRecord = $(this).clone();
                cloneBulkOrderRecord.find('td:first').remove();
                cloneBulkOrderRecord.find('td:last').remove();
                cloneBulkOrderRecord.find('td:first').removeClass('pr7').addClass('pr12');

                cloneBulkOrderRecord.appendTo('#confirmSkipToOtherBulkReportHolder');

                $('.procedureItem, .procedureItemWithRating, .procedureItemWithRatingv1').tooltip({
                    tooltipClass: 'jqueryTooltip',
                    //track: true,
                    content: function () {
                        return $(this).prop('title');
                    },
                    position: {
                        my: "left top",
                        at: "left bottom"
                    },
                    close: function (event, ui) {
                        $('.jqueryTooltip').remove();
                    },
                    show: function (event, ui) {
                        $('.jqueryTooltip').remove();
                    }
                });

                $('#confirmSkipToOtherBulkReport').dialog('open');
            }
        });

        $('td.goToOrderInBulk').on('click', function (e) {
            e.stopImmediatePropagation();
            e.stopPropagation();

            skipToOrder_UID = $(this).find('.bulkDictationOrder_UID').val();

            $('#confirmSkipToOtherBulkReportHolder').empty();

            var cloneBulkOrderRecord = $(this).parent().clone();
            cloneBulkOrderRecord.find('td:first').remove();
            cloneBulkOrderRecord.find('td:last').remove();
            cloneBulkOrderRecord.find('td:first').removeClass('pr7').addClass('pr12');

            cloneBulkOrderRecord.appendTo('#confirmSkipToOtherBulkReportHolder');

            $('.procedureItem, .procedureItemWithRating, .procedureItemWithRatingv1').tooltip({
                tooltipClass: 'jqueryTooltip',
                //track: true,
                content: function () {
                    return $(this).prop('title');
                },
                position: {
                    my: "left top",
                    at: "left bottom"
                },
                close: function (event, ui) {
                    $('.jqueryTooltip').remove();
                },
                show: function (event, ui) {
                    $('.jqueryTooltip').remove();
                }
            });


            $('#confirmSkipToOtherBulkReport').dialog('open');
        });

        $('#btnCloseConfirmToOtherBulkReport').on('click', function (e) {
            e.stopImmediatePropagation();
            e.stopPropagation();

            $('#confirmSkipToOtherBulkReport').dialog('close');
        });

        $('#btnSaveConfirmToOtherBulkReport').on('click', function (e) {
            e.stopImmediatePropagation();
            e.stopPropagation();

            $('#btnSaveAndCloseFile').trigger('click', [false]);
        });

        $('#btnValidateConfirmToOtherBulkReport').on('click', function (e) {
            e.stopImmediatePropagation();
            e.stopPropagation();

            $('#btnValidateAndCloseFile').trigger('click', [false]);
        });

        $('#btnContinueConfirmToOtherBulkReport').on('click', function (e) {
            e.stopImmediatePropagation();
            e.stopPropagation();
            const isToDictate = dictatedBy == null || dictatedBy == '';
            var resReq = setOrderAsSkippedInBulkSession(Model.OrderID, isToDictate ? 1 : 2).done(function (e) {
                if (resReq.responseJSON.AllOk) {
                    if (isToDictate) {
                        var resNextOrderBulk = getNextOrderToBulkDictate(skipToOrder_UID).done(function () {
                            $('#confirmSkipToOtherBulkReport').dialog('close');
                            $('#dialogNextOrderToBulkDictate').html(resNextOrderBulk.responseText);
                            checkIfAllChecked();
                        });
                    } else {
                        var resNextOrderBulk = getNextOrderToBulkValidate(skipToOrder_UID).done(function () {
                            $('#confirmSkipToOtherBulkReport').dialog('close');
                            $('#dialogNextOrderToBulkValidate').html(resNextOrderBulk.responseText);
                            checkIfAllChecked();
                        });
                    }
                }
                else {
                    alert("Error: " + data.Message);
                }
            });
        });

        $('#overviewToDictateInBulk h3').on('click', function (e) {
            e.stopImmediatePropagation();
            e.stopPropagation();

            if ($(this).parent().hasClass('active')) {
                $(this).parent().removeClass('active');
            }
            else {
                $(this).parent().addClass('active');
            }
        });

        $('body').on('click', function (e) {
            //e.stopImmediatePropagation();
            //e.stopPropagation();
            if ($(e.target).parents("#overviewToDictateInBulk").length == 0 && $(e.target).attr('id') != "overviewToDictateInBulk") {
                $('#overviewToDictateInBulk').removeClass('active');
            }
        });
    }

    $('#loading').show();
    $('div#contentView').hide();
    $('#validatedTab').empty();

    $('input#btnSkipFile').on('click', function (e) {
        if(userHasSpeechRecognition && useG2Speech)
            clearTimeout(window.pollG2Timeout);

        closeActiveSpeech().done(function () {
            const isToDictate = dictatedBy == null || dictatedBy == '';
            const resReq = setOrderAsSkippedInBulkSession(Model.OrderID, isToDictate ? 1 : 2).done(function (e) {
                if (resReq.responseJSON.AllOk) {
                    if (isToDictate) {
                        const resNextOrderBulk = getNextOrderToBulkDictate(null).done(function () {
                            $('#dialogNextOrderToBulkDictate').html(resNextOrderBulk.responseText);
                            checkIfAllChecked();
                        });
                    } else {
                        const resNextOrderBulk = getNextOrderToBulkValidate(null).done(function () {
                            $('#dialogNextOrderToBulkValidate').html(resNextOrderBulk.responseText);
                            checkIfAllChecked();
                        });
                    }
                } else {
                    alert("Error: " + data.Message);
                }
            });
        });
    });

    var setOrderAsDoneInBulkSessionReq = function (type) {
        var req = $.ajax({
            type: 'POST',
            url: '/legacy/Session/SetOrderAsDoneInBulkSession',
            dataType: 'json',
            data: {
                Order_UID: Model.OrderID,
                Type: type
            }
        });

        return req;
    };

    if(!screening)
    {
        //Initial setup editor
        if ($('div#divOrderReport').length > 0) {
            ReportSharedFunctions.InitTextEditor(Model);
        }
    }
    else
    {
        if (!Model.Validated && !Model.ReadOnly)
        {
            $('#request li.letter').removeClass('disabled');
            EditMode = true;
            if (Model.RequestFormInformation.PatientHasInvitationWith)
            {
                $('#request #ReferringPhysicianText').prop('disabled', true);
                $('#request #ReferringPhysicianText').css('background-color', '#EEE');
                $("#request #referringPhysActionMenu").menu("option", "disabled", true);
            }
        }

        $('div.tabsReportHolder').addClass('hasScreening');
        $('div.reportReportHolder ').addClass('hasScreening');

        var checkScreeningWidth = function(e) {
            var bodyWidth = $('body').width();
            if (bodyWidth < 1400) {
                $('.leftReportHolder').hide();
                $('.tabsReportHolder').hide();
            }
            else {
                $('.leftReportHolder').show();
                $('.tabsReportHolder').show();
            }
        };

        checkScreeningWidth();

        $(window).resize(function (e) {
            setTimeout(function (e) {
                checkScreeningWidth();
            }, 300);

        });
    }

    $('.validation').hide();
    $('.required').hide();

    $('#divDevalidateScreening').dialog({
        autoOpen: false,
        resizable: false,
        modal: true,
        appendTo: '#contentView',
        position: { my: "center", at: "center", of: '#contentView' },
        title: htmlDecode(window.Resources.Warning)
    });

    var checkModels = [];
    var gValidated;
    var gPreliminary;
    var gTriggerExportFormats;
    var gTranscription;
    var gClose;
    var gSupervisor_uid;

    $('#divSetCheckedBy').dialog({
        autoOpen: false,
        resizable: false,
        modal: true,
        appendTo: '#divPopupConfirmationChecksRemaining',
        dialogClass: 'divSetCheckedBy',
        position: { my: "center top", at: "center top+5", of: $('#divPopupConfirmationChecksRemaining') },
        title: $("<div/>").html(window.Resources.select + ' ' + window.Resources.User).text(),
        close: function () {
            if (!window.ChecksDialog.leavechecked) {
                var forcheck = $('#forCheckSetBy').val();
                $('tr.record' + forcheck + ' input.checkChecked').attr('checked', '');
                $('tr.record' + forcheck + ' input.checkChecked').prop('checked', false);
                $('tr.record' + forcheck + ' input.checkChecked').val(false);
            }
        }
    });

    $('#divSetRemarks').dialog({
        autoOpen: false,
        resizable: false,
        modal: true,
        appendTo: '#contentView',
        title: $("<div/>").html(window.Resources.Add + ' ' + window.Resources.Remarks).text()
    });

    $('#dialogReloadOrderDetailFile').dialog({
        autoOpen: false,
        resizable: false,
        modal: true,
        //position: { my: "center", at: "center", of: $("#subPageContent") },
        position: { my: "right top", at: "right-15 top+30", of: '#contentView' },
        title: htmlDecode(window.Resources.ReloadFile)
    });

    $('#divPopupConfirmationEmpty').dialog({
        autoOpen: false,
        resizable: false,
        modal: true,
        appendTo: '#contentView',
        position: { my: "center", at: "center", of: '#contentView' },
        title: htmlDecode(window.Resources.EmptyReport)
    });

    $('#reloadPage').on('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        $('#dialogReloadOrderDetailFile').dialog('open');
    });

    $('#btnOkReloadOrderDetailFileDialog').on('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        $('#dialogReloadOrderDetailFile').dialog('close');

        ReportSharedFunctions.LaunchEmptyPacsIntegration();
        closeActiveFile(false).done(function() {
            setTimeout(function () {
                $.ajax({
                    type: 'POST',
                    url: '/legacy/Locks/TryCreateLockFile',
                    data: {
                        LockType: LockType.Report,
                        RecordID: $('#lockableRecordID').text(),
                        Detail: true
                    },
                    async: false,
                    dataType: 'json',
                    success:
                        function (data) {
                            if (data.Done) {
                                window.addLocks(new URLSearchParams(window.location.search).get('fc') * 1, data.LockUIDs);
                                window.reloadActiveRazorView();
                            }
                            else if (!data.Done) {
                                window.showLockedFileDialog(data, $('span#rawUrl').text());
                            }
                        }
                });
            }, 1000);
        });
    });

    $('#btnCloseReloadOrderDetailFileDialog').on('click', function (e) {
        $('#dialogReloadOrderDetailFile').dialog('close');
    });

    $('.procedureItem, .physicianContactInfo').tooltip({
        tooltipClass: 'jqueryTooltip',
        //track: true,
        content: function () {
            return $(this).prop('title');
        },
        position: {
            my: "left top",
            at: "left bottom"
        },
        close: function (event, ui) {
            $('.jqueryTooltip').remove();
        },
        show: function (event, ui) {
            $('.jqueryTooltip').remove();
        }
    });

    $('.infoHoverPopup').hide();

    $('span.datetime').each(function (i, y) {
        var unformattedModDate = $(this).html();
        var m = moment(unformattedModDate, "MM/DD/YYYY hh:mm:ss A");
        if (m.isValid()) {
            $(this).html(m.calendar());
        }
    });

    window.reportGUID = Model.GUID;

    $('textarea#ReportContent').autosize();

    $('input#btnCloseFile').on('click', function (e) {
        $('body').off('click', 'ul.listFound li');
        ReportSharedFunctions.LaunchEmptyPacsIntegration();
        ReportSharedFunctions.SendORUOnClose(forOrder_ProcedureUIDs);
        closeActiveSpeech(Model.OrderNumber);
        closeActiveFile(true);
    });

    var updateProceduresToCorrection = false;

    var ValidateOrSaveAndCloseFunctionality = function (validated, close, supervisor_uid, transcription, preliminary, triggerExportFormats, reviewer_uid) {
        triggerExportFormats = triggerExportFormats || false;

        var deletedSpeechDocument = false;
        if ($('#editableContent').length > 0) {
            var val = $('#editableContent').val();
            if (val == "true") {
                deletedSpeechDocument = true;
            }
        }

        $('#btnValidateAndCloseFile').attr('disabled', true);
        $('#btnSaveAndCloseFile').attr('disabled', true);

        let labelsInReport = [];
        let urgencyInReport = null;

        if(typeof selectedLabels !== 'undefined')
            labelsInReport = selectedLabels;

        if(typeof selectedUrgency  !== 'undefined')
            urgencyInReport = selectedUrgency;

        $.ajax({
            type: 'POST',
            url: '/legacy/Locks/CheckLockFileBeforeSaving',
            data: { LockType: LockType.OrderReport, RecordID: Model.OrderID },
            async: false,
            dataType: 'json',
            success:
                function (data) {
                    if (data.Done) {
                        if (!screening) {
                            let reportContent = $('textarea#ReportContent').attr('value');
                            reportContent = reportContent?.replace(/<div>(.*?)<\/div>/gm, "$1<br>"); // TinyMCE handles <div>'s with a newline, but this doesn't happen everywhere (for example when rendering a report). So replacing those div's with <br> tags to fix this.
                            let orderID = Model.OrderID;
                            closeActiveSpeech(Model.OrderNumber).done(function (e) {

                                var orderDocumentsInformation = [];
                                $('.scannedOrderHolder').each(function (index, element) {
                                    var orderID = $(element).find('.scannedOrderID').val();
                                    var rotated = $(element).find('.scannedOrderRotated').val();
                                    var degrees = $(element).find('.scannedOrderDegrees').val();

                                    var subDocument = {
                                        Rotated: rotated,
                                        Degrees: degrees
                                    };

                                    if (!orderDocumentsInformation[index]) {
                                        orderDocumentsInformation[index] = {
                                            ID: orderID,
                                            SubDocuments: []
                                        };
                                    }

                                    orderDocumentsInformation[index].SubDocuments.push(subDocument);
                                });

                                $.ajax({
                                    type: "POST",
                                    url: '/legacy/Reports/MakeOrUpdateReport',
                                    async: false,
                                    data: {
                                        Order_UID: orderID,
                                        ForOrder_Procedure_UID: null,
                                        ReportContent: reportContent,
                                        Validated: validated,
                                        Preliminary: preliminary,
                                        Transcription: transcription,
                                        Supervisor_UID: supervisor_uid,
                                        GUID: reportGUID,
                                        DeletedSpeechDocument: deletedSpeechDocument,
                                        ProceduresToCorrection: updateProceduresToCorrection,
                                        SelectedLabels: labelsInReport,
                                        SelectedUrgency: urgencyInReport,
                                        TriggerAdHocExportFormats: (triggerExportFormats && preliminary),
                                        Reviewer_UID: reviewer_uid,
                                        OrderDocumentsInformation: orderDocumentsInformation
                                    },
                                    success: function (data) {
                                        $('#btnValidateAndCloseFile').removeAttr('disabled');
                                        $('#btnSaveAndCloseFile').removeAttr('disabled');

                                        if (data.PrintFail == true) {
                                            $('#divPrintFailDialog p#printMessage').html(data.Message);
                                            $('#divPrintFailDialog').dialog('open');
                                        }
                                        if (close) {
                                            ReportSharedFunctions.LaunchEmptyPacsIntegration();
                                            if (!inBulk) {
                                                closeActiveFile(true, true);
                                            }
                                            else {
                                                for (var i = 0; i < timeouts.length; i++) {
                                                    clearTimeout(timeouts[i]);
                                                }
                                                //quick reset of the timer array you just cleared
                                                timeouts = [];
                                                $('#loading').show();
                                                closeActiveSpeech(Model.OrderNumber).done(function () {
                                                    const isToDictate = dictatedBy == null || dictatedBy == '';
                                                    setOrderAsDoneInBulkSessionReq(isToDictate ? 1 : 2).done(function(doneInBulk) {
                                                        if (doneInBulk.AllOk) {
                                                            if (isToDictate) {
                                                                var resNextOrderBulk = getNextOrderToBulkDictate(null).done(function () {
                                                                    $('#dialogNextOrderToBulkDictate').html(resNextOrderBulk.responseText);
                                                                    checkIfAllChecked();
                                                                });
                                                            } else {
                                                                var resNextOrderBulk = getNextOrderToBulkValidate(null).done(function () {
                                                                    $('#dialogNextOrderToBulkValidate').html(resNextOrderBulk.responseText);
                                                                    checkIfAllChecked();
                                                                });
                                                            }
                                                        }
                                                        else {
                                                            alert("Error: " + doneInBulk.Message);
                                                        }
                                                    });
                                                });
                                            }
                                        }
                                    }
                                });
                            });
                        }
                        else {
                            var orderID = Model.OrderID;
                            var eachDone = false;
                            var arrLetters = [];
                            var arrPoints = [];
                            var arrCircles = [];

                            $('#orderReportWrapper li.letter').each(function (i, y) {
                                var id = $(y).attr('id');
                                var active = $(y).hasClass('active');
                                arrLetters.push([id, active]);
                            });

                            $('#orderReportWrapper div.mamPoint').each(function (i, y) {
                                var x = $(this).css('left');
                                var y = $(this).css('top');
                                arrPoints.push([x, y]);
                            });

                            $('#orderReportWrapper div.mamCircle').each(function(i, y) {
                                var x = $(this).css('left');
                                var y = $(this).css('top');
                                arrCircles.push([x, y]);
                            });

                            var arrPointsRequestForm = [];
                            var arrCirclesRequestForm = [];

                            $('#requestTab div.mamPoint').each(function (i, y) {
                                var x = $(this).css('left');
                                var y = $(this).css('top');
                                arrPointsRequestForm.push([x, y]);
                            });

                            $('#requestTab div.mamCircle').each(function(i, y) {
                                var x = $(this).css('left');
                                var y = $(this).css('top');
                                arrCirclesRequestForm.push([x, y]);
                            });

                            var screeningRequestForm = {
                                Order_UID: orderID,
                                Patient_RRN: $('#screeningTab dd#patientNationalRegisterNumber').text(),
                                Idgkb: $('#requestTab #Idgkb').val(),
                                Recall: $('#requestTab #Recall').val(),
                                PatientHasInvitationWith: $('#requestTab #PatientHasInvitationWith').val(),
                                PatientHasReferralWith: $('#requestTab #PatientHasReferralWith').val(),
                                ScreeningOtherDistrict: $('#requestTab #ScreeningOtherDistrict').val(),
                                AmountImages: $('#requestTab #AmountImages').val(),
                                Imager: $('#requestTab #ImagerFirstReader').prop('checked'),
                                IdentificationLaborant: $('#requestTab #IdentificationLaborant').val(),
                                MXType: $('#requestTab #MXType').val(),
                                DateMX: $('#requestTab #DateMX').val(),
                                AccessionNumber: $('#requestTab #AccessionNumber').val(),
                                PatientIdentificationNumber: $('#requestTab #PatientIdentificationNumber').val(),
                                HealthInsuranceText: $.trim($('#requestTab #HealthInsuranceText').val()),
                                InsuranceNumber: $('#requestTab #InsuranceNumber').val(),
                                GeneralPractitionerText: $.trim($('#requestTab #GeneralPractitionerText').val()),
                                Generalpractitioner_UID: $('#requestTab #GeneralPractitionerUIDGP').val(),
                                ReferringPhysicianText: $.trim($('#requestTab #ReferringPhysicianText').val()),
                                ReferringPhysician_UID: $('#requestTab #ReferringPhysician_UID').val(),
                                PhysicianCopy1Text: $.trim($('#requestTab #PhysicianCopy1Text').val()),
                                PhysicianCopy1_UID: $('#requestTab #PhysicianCopy1_UID').val(),
                                PhysicianCopy2Text: $.trim($('#requestTab #PhysicianCopy2Text').val()),
                                PhysicianCopy2_UID: $('#requestTab #PhysicianCopy2_UID').val(),
                                MXSentWith: $('#requestTab #MXSentWith').prop('checked'),
                                MXSentWithDate: $('#requestTab #MXSentWithDate').val(),
                                MXSentWithIsScreening: $('#requestTab #MXSentWithIsScreening').val(),
                                SendResultToGeneralPractitioner: $('#requestTab #SendResultToGeneralPractitioner').prop('checked'),
                                AllowCollectMonitoringData: $('#requestTab #AllowCollectMonitoringData').prop('checked'),
                                PrivacyDate: $('#requestTab #PrivacyDate').val(),
                                PrivacyProof: $('#requestTab #PrivacyProof').prop('checked'),
                                CurrentHormonalUse: $('#requestTab #CurrentHormonalUse').val(),
                                Menopause: $('#requestTab #Menopause').val(),
                                KnowledgeOfCancerInRelative: $('#requestTab #KnowledgeOfCancerInRelative').val(),
                                Outer_Right_Armpit: $('#requestTab #Outer_Right_Armpit').prop('checked'),
                                Outer_Right_ChestCentral: $('#requestTab #Outer_Right_ChestCentral').prop('checked'),
                                Outer_Right_ChestOuterUpper: $('#requestTab #Outer_Right_ChestOuterUpper').prop('checked'),
                                Outer_Right_ChestInnerUpper: $('#requestTab #Outer_Right_ChestInnerUpper').prop('checked'),
                                Outer_Right_ChestOuterUnder: $('#requestTab #Outer_Right_ChestOuterUnder').prop('checked'),
                                Outer_Right_ChestInnerUnder: $('#requestTab #Outer_Right_ChestInnerUnder').prop('checked'),
                                Outer_Right_NippleRetraction: $('#requestTab #Outer_Right_NippleRetraction').prop('checked'),
                                Outer_Right_NippleRetractionRecent: $('#requestTab #Outer_Right_NippleRetractionRecent').prop('checked'),
                                Outer_Right_WartsOrScars: $('#requestTab #Outer_Right_WartsOrScars').prop('checked'),
                                Outer_Left_Armpit: $('#requestTab #Outer_Left_Armpit').prop('checked'),
                                Outer_Left_ChestCentral: $('#requestTab #Outer_Left_ChestCentral').prop('checked'),
                                Outer_Left_ChestOuterUpper: $('#requestTab #Outer_Left_ChestOuterUpper').prop('checked'),
                                Outer_Left_ChestInnerUpper: $('#requestTab #Outer_Left_ChestInnerUpper').prop('checked'),
                                Outer_Left_ChestOuterUnder: $('#requestTab #Outer_Left_ChestOuterUnder').prop('checked'),
                                Outer_Left_ChestInnerUnder: $('#requestTab #Outer_Left_ChestInnerUnder').prop('checked'),
                                Outer_Left_NippleRetraction: $('#requestTab #Outer_Left_NippleRetraction').prop('checked'),
                                Outer_Left_NippleRetractionRecent: $('#requestTab #Outer_Left_NippleRetractionRecent').prop('checked'),
                                Outer_Left_WartsOrScars: $('#requestTab #Outer_Left_WartsOrScars').prop('checked'),
                                Remarks: $('#requestTab #Remarks').val(),
                                ArrPointsRequestForm: JSON.stringify(arrPointsRequestForm),
                                ArrCirclesRequestForm: JSON.stringify(arrCirclesRequestForm)
                            };

                            $.ajax({
                                type: "POST",
                                traditional: true,
                                url: '/legacy/Reports/MakeOrUpdateScreeningReport',
                                async: false,
                                data: {
                                    Order_UID: orderID,
                                    Report_UID: viewbagreport_UID,
                                    ForOrder_Procedure_UIDs: forOrder_ProcedureUIDs,
                                    ArrLetters: JSON.stringify(arrLetters),
                                    PatientNationalRegisterNumber: $('#orderReportWrapper dd#patientNationalRegisterNumber').text(),
                                    PatientName: $('#orderReportWrapper dd#patientName').text(),
                                    PatientDOB: $('#orderReportWrapper dd#patientDOB').text(),
                                    PatientAddress: $('#orderReportWrapper dd#patientAddress').text(),
                                    PatientRequestingPhysician: $('#orderReportWrapper dd#patientRequestingPhysician').text(),
                                    Reader: $('#orderReportWrapper #reader').val(),
                                    UserName: $('#orderReportWrapper #UserName').text(),
                                    LaborantID: $('#orderReportWrapper #beeldvormerLaborantID').val(),
                                    NumberImages: $('#orderReportWrapper #numberImages').val(),
                                    LastMXToCompare: $('#orderReportWrapper input#MXcompYes').prop('checked'),
                                    LastMXDate: $('#orderReportWrapper input#dateLastMX').val(),
                                    LastMXCompared: $('#orderReportWrapper input#compYes').prop('checked'),
                                    LastMXInjury: $('#orderReportWrapper input[name=injury][checked=checked]').val(),
                                    LastMXDigital: $('#orderReportWrapper input#MXCompareTypeDIGI').prop('checked'),
                                    Imager: $('#orderReportWrapper #beeldvormerLaborant').prop('checked'),
                                    Priority: $('#orderReportWrapper #prioritair').prop('checked'),
                                    PriorityReason: $('#orderReportWrapper #prioritairReason').val(),
                                    ImprovementNotPossibleReason: $('#orderReportWrapper #improvementNotPossible').val(),
                                    Remarks: $('#orderReportWrapper #comments').val(),
                                    ME: $('#orderReportWrapper #identificatieME').val(),
                                    ArrPoints: JSON.stringify(arrPoints),
                                    ArrCircles: JSON.stringify(arrCircles),
                                    Validated: validated,
                                    Template_Screening_UID: Model.ScreeningTemplate_UID,
                                    Supervisor_UID: supervisor_uid,
                                    RemoveOrder_Procedure_UIDs: '',
                                    AddOrder_Procedure_UIDs: '',
                                    Radiologist_UID: $('#orderReportWrapper #screeningRadiologist_UID').val(),
                                    Technician_UID: $('#orderReportWrapper #screeningTechnician_UID').val(),
                                    RequestFormInformation_Data: JSON.stringify(screeningRequestForm),
                                    SelectedLabels: labelsInReport
                                },
                                success: function (data) {
                                    if (data.PrintFail == true) {
                                        $('#divPrintFailDialog p#printMessage').html(data.Message);
                                        $('#divPrintFailDialog').dialog('open');
                                    }
                                    if (close) {
                                        ReportSharedFunctions.LaunchEmptyPacsIntegration();
                                        if (!inBulk) {
                                            closeActiveFile(true, true);
                                        }
                                        else {
                                            for (var i = 0; i < timeouts.length; i++) {
                                                clearTimeout(timeouts[i]);
                                            }
                                            //quick reset of the timer array you just cleared
                                            timeouts = [];
                                            $('#loading').show();
                                            closeActiveSpeech(Model.OrderNumber).done(function () {
                                                const isToDictate = dictatedBy == null || dictatedBy == '';
                                                $.ajax({
                                                    type: 'POST',
                                                    url: '/legacy/Session/SetOrderAsDoneInBulkSession',
                                                    dataType: 'json',
                                                    async: false,
                                                    data: {
                                                        Order_UID: Model.OrderID,
                                                        Type: isToDictate ? 1 : 2
                                                    },
                                                    success: function (data2) {
                                                        if (data2.AllOk) {
                                                            if (isToDictate) {
                                                                var resNextOrderBulk = getNextOrderToBulkDictate(null).done(function () {
                                                                    $('#dialogNextOrderToBulkDictate').html(resNextOrderBulk.responseText);
                                                                    checkIfAllChecked();
                                                                });
                                                            } else {
                                                                var resNextOrderBulk = getNextOrderToBulkValidate(null).done(function () {
                                                                    $('#dialogNextOrderToBulkValidate').html(resNextOrderBulk.responseText);
                                                                    checkIfAllChecked();
                                                                });
                                                            }
                                                        }
                                                        else {
                                                            alert("Error: " + data2.Message);
                                                        }
                                                    }
                                                });
                                            });
                                        }
                                    }
                                }
                            });
                        }
                    }
                    else if (!data.Done) {
                        $('#btnValidateAndCloseFile').removeAttr('disabled');
                        $('#btnSaveAndCloseFile').removeAttr('disabled');
                        $('#divNotLockedDialog').dialog('open');
                    }
                }
        });
    }

    // Needed to call ValidateOrCloseAndSave from _ReportDialogs JS context
    window.GlobalValidateOrSaveAndClose = (validated, close, transcription, preliminary, triggerExportFormats, reviewerID) => {
        toValidate = validated;
        toClose = close;
        toTranscription = transcription;
        toPreliminary = preliminary;
        toTriggerExportFormats = triggerExportFormats;

        ValidateOrSaveAndClose(toValidate, toClose, null, toTranscription, toPreliminary, toTriggerExportFormats, reviewerID);
    };

    var ValidateOrSaveAndClose = function (validated, close, supervisor_uid, transcription, preliminary, triggerExportFormats, reviewer_uid) {
        triggerExportFormats = triggerExportFormats || false;

        if (CheckReportDictatedForChecks(Model.OrderID))
        {
            ValidateOrSaveAndCloseFunctionality(validated, close, supervisor_uid, transcription, preliminary, triggerExportFormats, reviewer_uid);
        }
        else
        {
            gValidated = validated;
            gClose = close;
            gTranscription = transcription;
            gPreliminary = preliminary;
            gTriggerExportFormats = triggerExportFormats;
            gSupervisor_uid = supervisor_uid;
            $('#divPopupConfirmationChecksRemaining').dialog('open');
        }
    };

    var ShowUpdatedNomenclaturesCall = function (toReplace, replaceWith, procs, first) {
        var req = $.ajax({
            url: "/legacy/Reports/ShowUpdatedNomenclatures",
            type: "POST",
            //dataType: "json",
            traditional: true,
            data: {
                Order_UID: Model.OrderID,
                ProcedureReplacements: JSON.stringify(procs),
                First: first
            }
        });

        return req;
    };

    var GetToVerifyNomenclatures = function (toReplace, replaceWith, procs, first) {
        var res = ShowUpdatedNomenclaturesCall(toReplace, replaceWith, procs, first).done(function () {
            $('div#partialVerifyNomenclatures').html(res.responseText);
        });
    };

    if (!Model.ConfirmedInvoice) {
        GetToVerifyNomenclatures(0, 0, 0, true);
    }



    var UpdateOrderNomenclatures = function (ok) {
        var remarks = $('#confirmationRemarksText').val();

        var procs = [];
        $('tr.nomenGroup').each(function (i, obj) {
            var toRep = $(obj).find('input[name=EditableProcedure]').val();
            var toRepProc = $(obj).find('input[name=ProcedureID]').val();
            procs.push([toRep, toRepProc]);
        });

        var confirmInvoice = $('#ConfirmInvoiceOnConfirmation').prop('checked');
        var adjustInvoice = $('#AdjustInvoiceOnConfirmNomenclatures').prop('checked');

        $.ajax({
            type: 'POST',
            url: '/legacy/Reports/UpdateOrderAfterConfirmation',
            data: {
                Order_UID: Model.OrderID,
                Remarks: remarks,
                Ok: ok,
                ProcedureReplacements: JSON.stringify(procs),
                ConfirmInvoice: confirmInvoice,
                AdjustInvoice: adjustInvoice
            },
            async: false,
            dataType: 'json',
            success:
                function (data) {
                    if (data.AllOk) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
        });
    }

    var SaveAfterConfirmation = function (ok) {
        var validate = $('input#validatePopup').val();

        if (!ok) {
            updateProceduresToCorrection = true;
        }

        if (UpdateOrderNomenclatures(ok) && (validate == 1 || validate == 2 || validate == 3 || validate == 4)) {
            //closeActiveFile(true);
        }
        else {
            $('#verifyNomenclatures').hide();
            $('#divPopupConfirmation' + viewbagUniquePrefix).dialog('close');
        }

        //Validate and don't close yet
        if (validate == 1) {
            if (isAssistentRadiologist) {
                ShowPopupChooseSupervisor(true, true, false, false);
            }
            else {
                if (userRadiologistId != 0 && Model.SupervisorId != null && userRadiologistId !== Model.SupervisorId) {
                    ShowPopupSetCurrentRadiologistAsSupervisor(true, true, false, false)
                }
                else {
                    ValidateOrSaveAndClose(true, true, null, false, false);
                }
            }
        }
        //Don't validate and don't close yet
        else if (validate == 2) {
            if (isAssistentRadiologist) {
                ShowPopupChooseSupervisor(false, true, false, false);
            }
            else {
                ValidateOrSaveAndClose(false, true, null, false, false);
            }
        }
        //transcription & close
        else if (validate == 3) {
            if (isAssistentRadiologist) {
                ShowPopupChooseSupervisor(false, true, true, false);
            }
            else {
                ValidateOrSaveAndClose(false, true, null, true, false);
            }
        }
        //preliminary & close
        else if (validate == 4) {
            if (isAssistentRadiologist) {
                ShowPopupChooseSupervisor(false, true, false, true);
            }
            else {
                ValidateOrSaveAndClose(false, true, null, false, true);
            }
        }
    }

    $('button#btnNOKPopupConfirmation' + viewbagUniquePrefix).on('click', function (e) {
        SaveAfterConfirmation(false);
    });

    $('button#btnOKPopupConfirmation' + viewbagUniquePrefix).on('click', function (e) {
        SaveAfterConfirmation(true);
    });

    var showConfirmationPopup = function (validate) {
        $('#divPopupConfirmation' + viewbagUniquePrefix).find('input#validatePopup').val(validate);
        if (validate == 1) {
            $('#divPopupConfirmation' + viewbagUniquePrefix).dialog('option', 'title', $("<div/>").html(window.Resources.VerifyNomenclatures + ' - ' + window.Resources.ValidateAndClose).text());
        }
        else if (validate == 2) {
            $('#divPopupConfirmation' + viewbagUniquePrefix).dialog('option', 'title', $("<div/>").html(window.Resources.VerifyNomenclatures + ' - ' + window.Resources.SaveAndClose).text());
        }
        else if (validate == 3) {
            $('#divPopupConfirmation' + viewbagUniquePrefix).dialog('option', 'title', $("<div/>").html(window.Resources.VerifyNomenclatures + ' - ' + window.Resources.Transcription).text());
        }
        else if (validate == 4) {
            $('#divPopupConfirmation' + viewbagUniquePrefix).dialog('option', 'title', $("<div/>").html(window.Resources.VerifyNomenclatures + ' - ' + window.Resources.Preliminary).text());
        }
        else {
            $('#divPopupConfirmation' + viewbagUniquePrefix).dialog('option', 'title', $("<div/>").html(window.Resources.VerifyNomenclatures).text());
        }

        $('#divPopupConfirmation' + viewbagUniquePrefix).dialog('open');
    }

    var CheckReportContentBeforeSaving = function (dontCheckEmpty, action) {
        if (!showEmptyReportConfirmation || dontCheckEmpty)
        {
            return true;
        }
        else {
            if (!screening) {
                let reportContent = $('textarea#ReportContent').attr('value') ? $('textarea#ReportContent').attr('value') : '';
                reportContent = reportContent?.replace(/<div>(.*?)<\/div>/gm, "$1<br>");
                reportContent = reportContent.replace(/\r?\n/g, '<br>');
                reportContent = reportContent.replace(/<br>/gi, '');
                reportContent = reportContent.replace(/<br \/>/gi, '');
                reportContent = reportContent.replace(/<br\/>/gi, '');
                reportContent = reportContent.replace(/&nbsp;/gi, '');
                reportContent = $.trim(reportContent);
                if (!reportContent) {
                    if (action == 1) {
                        $('#toConfirmActionText').text(htmlDecode(window.Resources.toSave));
                        $('#toConfirmAction').val(1);
                    }
                    else if (action == 2) {
                        $('#toConfirmActionText').text(htmlDecode(window.Resources.toValidate));
                        $('#toConfirmAction').val(2);
                    }
                    else if (action == 3) {
                        $('#toConfirmActionText').text(htmlDecode(window.Resources.Transcription));
                        $('#toConfirmAction').val(3);
                    }
                    else if (action == 4) {
                        $('#toConfirmActionText').text(htmlDecode(window.Resources.Preliminary));
                        $('#toConfirmAction').val(4);
                    }
                    else if (action == 5){
                        $('#toConfirmActionText').text(htmlDecode(window.Resources.SendForReview));
                        $('#toConfirmAction').val(5);
                    }
                    $('#divPopupConfirmationEmpty').dialog('open');
                    return false;
                }
                return true;
            }
            else {
                return true;
            }
        }
    };

    $('#btnConfirmEmptyOk').on('click', function (e) {
        e.stopImmediatePropagation();
        e.stopPropagation();

        $("#divPopupConfirmationEmpty").dialog("close");

        var action = $('#toConfirmAction').val();
        if (action == 1) {
            $('#btnSaveAndCloseFile').trigger('click', [false, true]);
        }
        else if (action == 2) {
            $('#btnValidateAndCloseFile').trigger('click', [false, true]);
        }
        else if (action == 3) {
            $('#btnSendToTranscription').trigger('click', [false, true]);
        }
        else if (action == 4) {
            if (gTriggerExportFormats) {
                $('#btnSendToPreliminaryAndTriggerExportFormats').trigger('click', [false, true]);
            } else {
                $('#btnSendToPreliminary').trigger('click', [false, true]);
            }
        }
        else if (action == 5) {
            $('#divChooseReviewer').dialog('open');
        }
        $('#divPopupConfirmationEmpty').dialog('close');
    });

    $('#showAllImages').on('click', function(e){
        const numbers = Model.OrderProcedures.map(orderProcedure => orderProcedure.OrderHasProcedure_UID);
        ReportSharedFunctions.LaunchPacsIntegrationFor(numbers, multiple);
    })

    var inputDateRegex = /^([0-2][0-9]|3[0-1])[\/](0[1-9]|1[0-2])[\/]([12][90][0-9][0-9])$/;

    var ValidateScreeningInputFields = function(e) {
        //CHECK VALIDATED INPUT FIELDS
        var generalOK = true;
        var leftOK = true;
        var rightOK = true;
        var rightmessage = '';
        var leftmessage = '';
        var generalmessage = '';
        var LeftLocalisations = false;
        var RightLocalisations = false;

        //GET ARRPOINTS AND ARRCIRCLES
        var arrPoints = [];
        var arrCircles = [];

        $('#orderReportWrapper div.mamPoint').each(function (i, y) {
            var x = $(this).css('left');
            var y = $(this).css('top');
            arrPoints.push([x, y]);
        });

        $('#orderReportWrapper div.mamCircle').each(function (i, y) {
            var x = $(this).css('left');
            var y = $(this).css('top');
            arrCircles.push([x, y]);
        });

        $.ajax({
            type: "POST",
            traditional: true,
            url: '/legacy/Reports/GetLeftRightPointsAndCircles',
            async: false,
            data: {
                ArrPoints: JSON.stringify(arrPoints),
                ArrCircles: JSON.stringify(arrCircles)

            },
            success: function (data) {
                if(data.AllOk)
                {
                    LeftLocalisations = data.Left;
                    RightLocalisations = data.Right;
                }
            },
            error: function(request, textStatus, errorThrown) {
                alert("request: " + request.responseText + "; Status: " + textStatus + "; Error: " + errorThrown);
            }
        });

        //RRN HAS TO BE KNOWN FOR PATIENT
        if($('#patientNationalRegisterNumber').text() == "{patientNationalRegisterNumber}" || $.trim($('#patientNationalRegisterNumber').text()) == "")
        {
            generalOK = false;
            generalmessage += "<p>Rijksregisternummer van de patiënt dient gekend te zijn. Update de patiënt.</p>";
        }


        //REGEXKES
        if ($('#MXcompYes').prop('checked')) {
            var lastMX = $('#dateLastMX').val();
            if ($.trim(lastMX) == "" || !inputDateRegex.test(lastMX)) {
                generalOK = false;
                $('div#dateLastMXDiv span.required').show();
                generalmessage += "<p>Datum vergeleken MX heeft niet het correcte formaat (dd/MM/yyyy)</p>";
            }
            else
            {
                if(new Date(lastMX.split("/")[2],parseInt(lastMX.split("/")[1])-1,lastMX.split("/")[0]) >= Date.now())
                {
                    generalOK = false;
                    $('div#dateLastMXDiv span.required').show();
                    generalmessage += "<p>Datum vergeleken MX dient in het verleden te liggen.</p>";
                }
                if(new Date(lastMX.split("/")[2],parseInt(lastMX.split("/")[1])-1,lastMX.split("/")[0]) >= new Date(Model.OrderDateOfImplementation.substr(6,4),parseInt(Model.OrderDateOfImplementation.substr(3,2))-1,Model.OrderDateOfImplementation.substr(0,2)))
                {
                    generalOK = false;
                    $('div#dateLastMXDiv span.required').show();
                    generalmessage += "<p>Datum vergeleken MX dient kleiner te zijn dan MX datum.</p>";
                }
            }
        }

        //AANTAL HAS TO BE > 0
        var aantalBeelden = $('#numberImages').val();
        if(aantalBeelden <= 0)
        {
            generalOK = false;
            $('div#numberImagesDiv span.required').show();
            generalmessage += "<p>Aantal beelden dient groter te zijn dan 0</p>";
        }

        //READER HAS TO HAVE LENGTH 8
        if($('#reader').val().length != 8)
        {
            generalOK = false;
            $('div#readerDiv span.required').show();
            generalmessage += "<p>Lezer dient 8 getallen lang te zijn</p>";
        }

        //ME HAS TO BE NUMERIC
        if(!$.isNumeric($('#identificatieME').val()))
        {
            generalOK = false;
            $('div#MEDiv span.required').show();
            generalmessage += "<p>ME dient numeriek te zijn</p>";
        }

        //WHEN TECHNICAL QUALITY IS NOT GOOD BUT NOT POSSIBLE TO DO BETTER, A REASON HAS TO BE GIVEN
        if($('#032R').hasClass('active') && $.trim($('#improvementNotPossible').val()) == "")
        {
            rightOK = false;
            rightmessage += "<p>Gelieve een reden op te geven waarom de technische kwaliteit niet beter kan.</p>";
        }
        if($('#032L').hasClass('active') && $.trim($('#improvementNotPossible').val()) == "")
        {
            leftOK = false;
            leftmessage += "<p>Gelieve een reden op te geven waarom de technische kwaliteit niet beter kan.</p>";
        }

        //WHEN PRIORITY CHECKBOX IS CHECKED, A REASON HAS TO BE GIVEN
        if($('#prioritair').prop('checked') && $('#prioritairReason').val().trim().length === 0)
        {
            generalOK = false;
            $('div#priorityDiv span.required').show();
            generalmessage += "<p>Gelieve een reden op te geven voor prioritair behandelen</p>";
        }

        //WHEN A PRIORITY REASON IS GIVEN AND THE CHECKBOX IS NOT CHECKED
        if(!$('#prioritair').prop('checked') && $.trim($('#prioritairReason').val()).length != 0)
        {
            generalOK = false;
            $('div#priorityDiv span.required').show();
            generalmessage += "<p>Er werd een reden opgegeven voor prioritair behandelen, maar de checkbox is niet actief.</p>";
        }

        //IF CALCIFICATIONS ARE SUSPICIOUS, AT LEAST ONE LOCALISATION HAS TO BE GIVEN
        if($('#035R').hasClass('active') && ($('#011R').hasClass('active') || $('#002R').hasClass('active')))
        {
            if(!RightLocalisations)
            {
                rightOK = false;
                rightmessage += "<p>Gelieve minstens 1 localisatie aan te duiden.</p>";
            }
        }
        if(($('#035L').hasClass('active') && ($('#011L').hasClass('active')) ||$('#002L').hasClass('active')))
        {
            if(!LeftLocalisations)
            {
                leftOK = false;
                leftmessage += "<p>Gelieve minstens 1 localisatie aan te duiden.</p>";
            }
        }


        //LOCALISATIONS NOT ALLOWED WHEN NOT SUSPICIOUS
        if($('#010R').hasClass('active') && $('#001R').hasClass('active'))
        {
            if(RightLocalisations)
            {
                rightOK = false;
                rightmessage += "<p>Er mogen geen localisaties opgegeven worden indien geen verdachte afwijkingen of calcificaties</p>";
            }
        }
        if($('#010L').hasClass('active') && $('#001L').hasClass('active'))
        {
            if(LeftLocalisations)
            {
                leftOK = false;
                leftmessage += "<p>Er mogen geen localisaties opgegeven worden indien geen verdachte afwijkingen of calcificaties</p>";
            }
        }

        //WHEN CONCLUSION IS "VERDERE OPPUNTSTELLING" THEN "TE WEERHOUDEN OMWILLE VAN" AND/OR "VERDACHT" HAS TO BE FILLED OUT AND THE "GEVOLG" HAS TO BE "VERDER ONDERZOEK"
        if($('#035R').hasClass('active'))
        {
            if((!$('#002R').hasClass('active') && !$('#011R').hasClass('active')) || !$('#039R').hasClass('active'))
            {
                rightOK = false;
                rightmessage += "<p>Indien conclusie 'Verdere oppuntstelling' is, dan moet 'te weerhouden omwille van' en/of 'verdacht' ingevuld zijn en dient het gevolg 'verder onderzoek' te zijn.</p>";
            }

        }
        if($('#035L').hasClass('active'))
        {
            if((!$('#002L').hasClass('active') && !$('#011L').hasClass('active')) || !$('#039L').hasClass('active'))
            {
                leftOK = false;
                leftmessage += "<p>Indien conclusie 'Verdere oppuntstelling' is, dan moet 'te weerhouden omwille van' en/of 'verdacht' ingevuld zijn en dient het gevolg 'verder onderzoek' te zijn.</p>";
            }
        }


        //IF CONCLUSION IS NOT "VERDERE OPPUNTSTELLING", "Te weerhouden omwille van" AND/OR "VERDACHT" ARE NOT ALLOWED TO BE FILLED OUT
        if(!$('#035R').hasClass('active'))
        {
            if(!$('#035R').hasClass('active') && ($('#002R').hasClass('active') || $('#011R').hasClass('active')))
            {
                rightOK = false;
                rightmessage += "<p>Indien conclusie verschillend is van 'Verdere oppuntstelling', dan is het niet toegestaan 'verdacht' of 'te weerhouden omwille van' in te vullen.</p>";
            }
        }
        if(!$('#035L').hasClass('active'))
        {
            if(!$('#035L').hasClass('active') && ($('#002L').hasClass('active') || $('#011L').hasClass('active')))
            {
                leftOK = false;
                leftmessage += "<p>Indien conclusie verschillend is van 'Verdere oppuntstelling', dan is het niet toegestaan 'verdacht' of 'te weerhouden omwille van' in te vullen.</p>";
            }
        }

        //IF LABORANT IS CHECKED, AN ID HAS TO BE GIVEN FOR THE LABORANT
        if($('#beeldvormerLaborant').is(':checked') && $.trim($('#beeldvormerLaborantID').val()) == "")
        {
            generalOK = false;
            $('div#laborantDiv span.required').show();
            generalmessage += "<p>Gelieve een laborant ID op te geven.</p>";
        }

        //IF TECHNICAL REASON IS "NIET GOED MAAR KAN NIET BETER" THEN CONCLUSION CAN NOT BE RECALL
        if($('#032R').hasClass('active') && $('#036R').hasClass('active'))
        {
            rightOK = false;
            rightmessage += "<p>Als 'niet goed maar kan niet beter', dan moet conclusie 'geen afwijking', 'goedaardige afwijking' of 'verdere oppuntstelling' zijn.</p>";
        }
        if($('#032L').hasClass('active') && $('#036L').hasClass('active'))
        {
            leftOK = false;
            leftmessage += "<p>Als 'niet goed maar kan niet beter', dan moet conclusie 'geen afwijking', 'goedaardige afwijking' of 'verdere oppuntstelling' zijn.</p>";
        }

        //CHECK IF ANY AFWIJKING HAS BEEN SELECTED, WHEN CONCLUSION IS NOT RECALL OR MASTECTOMY
        if(!$('#036R').hasClass('active') && !$('#037R').hasClass('active'))
        {
            if(!$('#001R').hasClass('active') && !$('#002R').hasClass('active') && !$('#003R').hasClass('active') && !$('#004R').hasClass('active') && !$('#005R').hasClass('active') && !$('#006R').hasClass('active') && !$('#007R').hasClass('active') && !$('#008R').hasClass('active') && !$('#009R').hasClass('active'))
            {
                rightOK = false;
                rightmessage += "<p>Gelieve de sectie 'Afwijking' in te vullen.</p>";
            }
        }
        if(!$('#036L').hasClass('active') && !$('#037L').hasClass('active'))
        {
            if(!$('#001L').hasClass('active') && !$('#002L').hasClass('active') && !$('#003L').hasClass('active') && !$('#004L').hasClass('active') && !$('#005L').hasClass('active') && !$('#006L').hasClass('active') && !$('#007L').hasClass('active') && !$('#008L').hasClass('active') && !$('#009L').hasClass('active'))
            {
                leftOK = false;
                leftmessage += "<p>Gelieve de sectie 'Afwijking' in te vullen.</p>";
            }
        }

        //CHECK IF ANY CALCIFICATION HAS BEEN SELECTED, WHEN CONCLUSION IS NOT RECALL OR MASTECTOMY
        if(!$('#036R').hasClass('active') && !$('#037R').hasClass('active'))
        {
            if(!$('#010R').hasClass('active') && !$('#011R').hasClass('active'))
            {
                rightOK = false;
                rightmessage += "<p>Gelieve de sectie 'Calcificaties' in te vullen.</p>";
            }
        }
        if(!$('#036L').hasClass('active') && !$('#037L').hasClass('active'))
        {
            if(!$('#010L').hasClass('active') && !$('#011L').hasClass('active'))
            {
                leftOK = false;
                leftmessage += "<p>Gelieve de sectie 'Calcificaties' in te vullen.</p>";
            }
        }

        //CHECK IF ANY SAMENSTELLING BORSTWEEFSEL HAS BEEN SELECTED, WHEN CONCLUSION IS NOT RECALL OR MASTECTOMY
        if(!$('#036R').hasClass('active') && !$('#037R').hasClass('active'))
        {
            if(!$('#012R').hasClass('active') && !$('#013R').hasClass('active') && !$('#014R').hasClass('active') && !$('#015R').hasClass('active'))
            {
                rightOK = false;
                rightmessage += "<p>Gelieve de sectie 'Samenstelling Borstweefsel' in te vullen.</p>";
            }
        }
        if(!$('#036L').hasClass('active') && !$('#037L').hasClass('active'))
        {
            if(!$('#012L').hasClass('active') && !$('#013L').hasClass('active') && !$('#014L').hasClass('active') && !$('#015L').hasClass('active'))
            {
                leftOK = false;
                leftmessage += "<p>Gelieve de sectie 'Samenstelling Borstweefsel' in te vullen.</p>";
            }
        }

        //CHECK IF ANY SAMENSTELLING BORSTWEEFSEL HAS BEEN SELECTED, WHEN CONCLUSION IS NOT MASTECTOMY
        if(!$('#037R').hasClass('active'))
        {
            if(!$('#016R').hasClass('active') && !$('#017R').hasClass('active') && !$('#018R').hasClass('active') && !$('#019R').hasClass('active') && !$('#020R').hasClass('active') && !$('#021R').hasClass('active') && !$('#022R').hasClass('active') && !$('#023R').hasClass('active') && !$('#024R').hasClass('active') && !$('#025R').hasClass('active') && !$('#026R').hasClass('active') && !$('#027R').hasClass('active') && !$('#028R').hasClass('active') && !$('#029R').hasClass('active') && !$('#030R').hasClass('active') && !$('#031R').hasClass('active') && !$('#032R').hasClass('active'))
            {
                rightOK = false;
                rightmessage += "<p>Gelieve de sectie 'Technische Kwaliteit' in te vullen.</p>";
            }
        }
        if(!$('#037L').hasClass('active'))
        {
            if(!$('#016L').hasClass('active') && !$('#017L').hasClass('active') && !$('#018L').hasClass('active') && !$('#019L').hasClass('active') && !$('#020L').hasClass('active') && !$('#021L').hasClass('active') && !$('#022L').hasClass('active') && !$('#023L').hasClass('active') && !$('#024L').hasClass('active') && !$('#025L').hasClass('active') && !$('#026L').hasClass('active') && !$('#027L').hasClass('active') && !$('#028L').hasClass('active') && !$('#029L').hasClass('active') && !$('#030L').hasClass('active') && !$('#031L').hasClass('active') && !$('#032L').hasClass('active'))
            {
                leftOK = false;
                leftmessage += "<p>Gelieve de sectie 'Technische Kwaliteit' in te vullen.</p>";
            }
        }

        //CHECK IF ANY CONCLUSION HAS BEEN SELECTED
        if(!$('#033R').hasClass('active') && !$('#034R').hasClass('active') && !$('#035R').hasClass('active') && !$('#036R').hasClass('active') && !$('#037R').hasClass('active'))
        {
            rightOK = false;
            rightmessage += "<p>Gelieve de sectie 'Conclusie' in te vullen.</p>";
        }
        if(!$('#033L').hasClass('active') && !$('#034L').hasClass('active') && !$('#035L').hasClass('active') && !$('#036L').hasClass('active') && !$('#037L').hasClass('active'))
        {
            leftOK = false;
            leftmessage += "<p>Gelieve de sectie 'Conclusie' in te vullen.</p>";
        }

        //CHECK IF ANY GEVOLG HAS BEEN SELECTED, WHEN CONCLUSION IS NOT RECALL OR MASTECTOMY
        if(!$('#036R').hasClass('active') && !$('#037R').hasClass('active'))
        {
            if(!$('#038R').hasClass('active') && !$('#039R').hasClass('active') && !$('#040R').hasClass('active') && !$('#041R').hasClass('active') && !$('#042R').hasClass('active') && !$('#043R').hasClass('active'))
            {
                rightOK = false;
                rightmessage += "<p>Gelieve de sectie 'Gevolg' in te vullen.</p>";
            }
        }
        if(!$('#036L').hasClass('active') && !$('#037L').hasClass('active'))
        {
            if(!$('#038L').hasClass('active') && !$('#039L').hasClass('active') && !$('#040L').hasClass('active') && !$('#041L').hasClass('active') && !$('#042L').hasClass('active') && !$('#043L').hasClass('active'))
            {
                leftOK = false;
                leftmessage += "<p>Gelieve de sectie 'Gevolg' in te vullen.</p>";
            }
        }

        //IF 'TE WEERHOUDEN OMWILLE VAN' THEN SOLITAIR OR MEERDERE HAS TO BE SELECTED
        if($('#002R').hasClass('active') && (!$('#008R').hasClass('active') && !$('#009R').hasClass('active')))
        {
            rightOK = false;
            rightmessage += "<p>Indien 'te weerhouden omwille van' is ingevuld, dient 'solitair' of 'meerdere' geselecteerd te worden.</p>";
        }
        if($('#002L').hasClass('active') && (!$('#008L').hasClass('active') && !$('#009L').hasClass('active')))
        {
            leftOK = false;
            leftmessage += "<p>Indien 'te weerhouden omwille van' is ingevuld, dient 'solitair' of 'meerdere' geselecteerd te worden.</p>";
        }

        //IF 'TE WEERHOUDEN OMWILLE VAN' THEN UNDERLYING REASON HAS TO BE SELECTED
        if($('#002R').hasClass('active') && (!$('#003R').hasClass('active') && !$('#004R').hasClass('active') && !$('#005R').hasClass('active') && !$('#006R').hasClass('active') && !$('#007R').hasClass('active')))
        {
            rightOK = false;
            rightmessage += "<p>Indien 'te weerhouden omwille van' is ingevuld, dient een onderliggende reden geselecteerd te worden.</p>";
        }
        if($('#002L').hasClass('active') && (!$('#003L').hasClass('active') && !$('#004L').hasClass('active') && !$('#005L').hasClass('active') && !$('#006L').hasClass('active') && !$('#007L').hasClass('active')))
        {
            leftOK = false;
            leftmessage += "<p>Indien 'te weerhouden omwille van' is ingevuld, dient een onderliggende reden geselecteerd te worden.</p>";
        }

        //IF A REASON WHY NIET GOED MAAR KAN NIET BETER IS GIVEN, BUT THE BUTTON IS NOT ACTIVE
        if((!$('#032R').hasClass('active') && !$('#032L').hasClass('active')) && $.trim($('#improvementNotPossible').val()).length > 0)
        {
            generalOK = false;
            generalmessage += "<p>Er werd een reden opgegeven, maar 'Niet goed maar kan niet beter' is niet actief.</p>";
        }

        //TECHNICAL QUALITY NOT GOOD, BUT NO REASON SELECTED
        if($('#019R').hasClass('active') && !$('#020R').hasClass('active') && !$('#021R').hasClass('active') && !$('#022R').hasClass('active') && !$('#023R').hasClass('active'))
        {
            rightOK = false;
            rightmessage += "<p>Gelieve een reden waarom 'Niet goed technisch-fysisch' aan te duiden.</p>";
        }
        if($('#019L').hasClass('active') && !$('#020L').hasClass('active') && !$('#021L').hasClass('active') && !$('#022L').hasClass('active') && !$('#023L').hasClass('active'))
        {
            leftOK = false;
            leftmessage += "<p>Gelieve een reden waarom 'Niet goed technisch-fysisch' aan te duiden.</p>";
        }
        if($('#024R').hasClass('active') && !$('#025R').hasClass('active') && !$('#026R').hasClass('active') && !$('#027R').hasClass('active') && !$('#028R').hasClass('active') && !$('#029R').hasClass('active') && !$('#030R').hasClass('active') && !$('#031R').hasClass('active') && !$('#032R').hasClass('active'))
        {
            rightOK = false;
            rightmessage += "<p>Gelieve een reden waarom 'Niet goed positionering' aan te duiden.</p>";
        }
        if($('#024L').hasClass('active') && !$('#025L').hasClass('active') && !$('#026L').hasClass('active') && !$('#027L').hasClass('active') && !$('#028L').hasClass('active') && !$('#029L').hasClass('active') && !$('#030L').hasClass('active') && !$('#031L').hasClass('active') && !$('#032L').hasClass('active'))
        {
            leftOK = false;
            leftmessage += "<p>Gelieve een reden waarom 'Niet goed positionering' aan te duiden.</p>";
        }

        //FURTHER INVESTIGATION SELECTED, BUT NO REASON
        if($('#039R').hasClass('active') && !$('#040R').hasClass('active') && !$('#041R').hasClass('active') && !$('#042R').hasClass('active') && !$('#043R').hasClass('active'))
        {
            rightOK = false;
            rightmessage += "<p>Gelieve een reden voor 'Verder onderzoek' te selecteren.</p>";
        }
        if($('#039L').hasClass('active') && !$('#040L').hasClass('active') && !$('#041L').hasClass('active') && !$('#042L').hasClass('active') && !$('#043L').hasClass('active'))
        {
            leftOK = false;
            leftmessage += "<p>Gelieve een reden voor 'Verder onderzoek' te selecteren.</p>";
        }

        //WHEN MASTECTOMY OR RECALL, NO LOCALISATIONS CAN BE PRESENT
        if($('#036R').hasClass('active') || $('#037R').hasClass('active'))
        {
            if(RightLocalisations)
            {
                rightOK = false;
                rightmessage += "<p>Er mogen geen localisaties opgegeven worden indien technisch niet interpreteerbaar of mastectomie.</p>";
            }
        }
        if($('#036L').hasClass('active') || $('#037L').hasClass('active'))
        {
            if(LeftLocalisations)
            {
                leftOK = false;
                leftmessage += "<p>Er mogen geen localisaties opgegeven worden indien technisch niet interpreteerbaar of mastectomie.</p>";
            }
        }

        //WHEN 'VERDER ONDERZOEK' IS NOT SELECTED, BUT ONE OF THE UNDERLYING REASONS IS SELECTED
        if(!$('#039R').hasClass('active') && ($('#040R').hasClass('active') || $('#041R').hasClass('active') || $('#042R').hasClass('active') || $('#043R').hasClass('active')))
        {
            rightOK = false;
            rightmessage += "<p>Er werd een gevolg voor 'Verder onderzoek' aangeduid, hoewel 'verder onderzoek' niet geselecteerd werd.</p>";
        }
        if(!$('#039L').hasClass('active') && ($('#040L').hasClass('active') || $('#041L').hasClass('active') || $('#042L').hasClass('active') || $('#043L').hasClass('active')))
        {
            rightOK = false;
            rightmessage += "<p>Er werd een gevolg voor 'Verder onderzoek' aangeduid, hoewel 'verder onderzoek' niet geselecteerd werd.</p>";
        }

        $('span.validationAreaGeneral').html(generalmessage);
        $('span.validationAreaRight').html('<p>R:</p>' + rightmessage);
        $('span.validationAreaLeft').html('<p>L:</p>' + leftmessage);

        if(!generalOK)
            $('span.validationAreaGeneral').show();
        if(!leftOK)
            $('span.validationAreaLeft').show();
        if(!rightOK)
            $('span.validationAreaRight').show();

        return generalOK && leftOK && rightOK;

    };

    $('ul#urgentList li').on('click', function (e) {
        if (!validatedModel && !readOnly) {
            if (!$('div#subPageContent').hasClass('disabled')) {
                if (!$(this).hasClass('default')) {
                    $('ul#urgentList li.default').removeClass('default');
                    $(this).addClass('default');
                    selectedUrgency = $(this).attr('id');
                }
            }
        }
    });

    function TriggerExportFormats() {
        $('.triggerExportFormatsMessage').html(window.Resources.SendingReport);
        $.ajax({
            type: 'POST',
            data: {
                orderUid: Model.OrderID,
                reportUid: Model.FullOrderReport_UID
            },
            url: '/legacy/Reports/TriggerReportExportFormats',
            dataType: 'json',
            success: function (data) {
                if (data.AllOk == true) {
                    $('.triggerExportFormatsMessage').html(window.Resources.ReportWasSentOn + " " + moment().format("DD/MM/YYYY hh:mm:ss A"))
                } else {
                    alert("Printing failed");
                    $('.triggerExportFormatsMessage').html("")
                }
            }
        });
    }

    $('input#btnTriggerExportFormats').on('click', function (e) {
        TriggerExportFormats();
    });

    $('input#btnSendToTranscription').on('click', function (e, fromEOL, dontCheckEmpty) {
        if (screening) {
            $('span.validationAreaGeneral').hide();
            $('span.validationAreaLeft').hide();
            $('span.validationAreaRight').hide();
            if(!ValidateScreeningInputFields())
            {
                $("#screeningvalidationdiv")[0].scrollIntoView(true);
                return;
            }
            if (!noRequestForm)
            {
                if(!ValidateRequestFormInputFields(true))
                {
                    $('a[href="#requestTab"]').trigger('click');
                    $("#request #validationdiv")[0].scrollIntoView(true);
                    return;
                }
            }
        }
        //CHECK G2
        if (typeof dontCheckEmpty == "undefined") {
            dontCheckEmpty = false;
        }
        if (typeof fromEOL == "undefined") {
            fromEOL = false;
        }

        if (!fromEOL && userHasSpeechRecognition && useG2Speech && !dontCheckEmpty && !screening) {

            clearTimeout(window.pollG2Timeout);
            $('#btnValidateAndCloseFile').attr('disabled', true);
            $('#btnSaveAndCloseFile').attr('disabled', true);

            closeActiveSpeech(Model.OrderNumber).done(function (e) {
                $('#btnValidateAndCloseFile').removeAttr('disabled');
                $('#btnSaveAndCloseFile').removeAttr('disabled');

                $.ajax({
                    type: "GET",
                    url: "/legacy/Reports/GetG2SpeechDocumentOnSaveAndClose",
                    async: false,
                    data: {
                        GUID: reportGUID,
                        Order_UID: Model.OrderID
                    },
                    timeout: 15000,
                    success: function (data) {
                        clearTimeout(window.pollG2Timeout);

                        if ((data.AllOk || (data.ErrorG2 && !data.SpeechDocumentExists && $('#editableContent').val() == "true")) && $('#editableContent').val() == "false") {
                            if (data.ReportGUID)
                            {
                                reportGUID = data.ReportGUID;
                            }
                            $('#startSpeechRecognition').removeClass('disabled');
                            tinymce.activeEditor.setContent(data.Result);
                        }
                        else if (data.ErrorG2) {
                            $('#startSpeechRecognition').removeClass('disabled');
                            alert(data.ErrorMessage);
                            return false;
                        }
                        else if (data.Error) {
                            console.log('Error getting G2speechdocumentOnSaveAndClose');
                            $('#startSpeechRecognition').removeClass('disabled');
                        }

                        if (CheckReportContentBeforeSaving(dontCheckEmpty, 3)) {
                            if (showConfirmationOnSave) {
                                showConfirmationPopup(3);
                            }
                            else {
                                if (isAssistentRadiologist) {
                                    ShowPopupChooseSupervisor(false, true, true, false);
                                }
                                else {
                                    ValidateOrSaveAndClose(false, true, null, true, false);
                                }
                            }
                        }
                    }
                });
            }).error(function(e) {
                $('#btnValidateAndCloseFile').removeAttr('disabled');
                $('#btnSaveAndCloseFile').removeAttr('disabled');
            });

        }
        else {
            if (CheckReportContentBeforeSaving(dontCheckEmpty, 3)) {
                if (showConfirmationOnSave) {
                    showConfirmationPopup(3);
                }
                else {
                    if (isAssistentRadiologist) {
                        ShowPopupChooseSupervisor(false, true, true, false);
                    }
                    else {
                        ValidateOrSaveAndClose(false, true, null, true, false);
                    }
                }
            }
        }
    });

    function SendToPreliminary(e, fromEOL, dontCheckEmpty, triggerExportFormats) {
        if (screening) {
            $('span.validationAreaGeneral').hide();
            $('span.validationAreaLeft').hide();
            $('span.validationAreaRight').hide();
        }
        //CHECK G2
        if (typeof dontCheckEmpty == "undefined") {
            dontCheckEmpty = false;
        }
        if (typeof fromEOL == "undefined") {
            fromEOL = false;
        }

        if (!fromEOL && userHasSpeechRecognition && useG2Speech && !dontCheckEmpty && !screening) {

            clearTimeout(window.pollG2Timeout);
            $('#btnValidateAndCloseFile').attr('disabled', true);
            $('#btnSaveAndCloseFile').attr('disabled', true);

            closeActiveSpeech(Model.OrderNumber).done(function (e) {

                $('#btnValidateAndCloseFile').removeAttr('disabled');
                $('#btnSaveAndCloseFile').removeAttr('disabled');

                $.ajax({
                    type: "GET",
                    url: "/legacy/Reports/GetG2SpeechDocumentOnSaveAndClose",
                    async: false,
                    data: {
                        GUID: reportGUID,
                        Order_UID: Model.OrderID
                    },
                    timeout: 15000,
                    success: function (data) {
                        clearTimeout(window.pollG2Timeout);

                        if ((data.AllOk || (data.ErrorG2 && !data.SpeechDocumentExists && $('#editableContent').val() == "true")) && $('#editableContent').val() == "false") {
                            if (data.ReportGUID)
                            {
                                reportGUID = data.ReportGUID;
                            }
                            $('#startSpeechRecognition').removeClass('disabled');
                            tinymce.activeEditor.setContent(data.Result);
                        }
                        else if (data.ErrorG2) {
                            $('#startSpeechRecognition').removeClass('disabled');
                            alert(data.ErrorMessage);
                            return false;
                        }

                        if (CheckReportContentBeforeSaving(dontCheckEmpty, 4)) {
                            if (showConfirmationOnSave) {
                                showConfirmationPopup(4);
                            }
                            else {
                                if (isAssistentRadiologist) {
                                    ShowPopupChooseSupervisor(false, true, false, true, triggerExportFormats);
                                }
                                else {
                                    ValidateOrSaveAndClose(false, true, null, false, true, triggerExportFormats);
                                }
                            }
                        }
                    }
                });
            }).error(function(e) {
                $('#btnValidateAndCloseFile').removeAttr('disabled');
                $('#btnSaveAndCloseFile').removeAttr('disabled');
            });

        }
        else {
            if (CheckReportContentBeforeSaving(dontCheckEmpty, 4)) {
                if (showConfirmationOnSave) {
                    showConfirmationPopup(4);
                }
                else {
                    if (isAssistentRadiologist) {
                        ShowPopupChooseSupervisor(false, true, false, true, triggerExportFormats);
                    }
                    else {
                        ValidateOrSaveAndClose(false, true, null, false, true, triggerExportFormats);
                    }
                }
            }
        }
    }

    $('input#btnSendToPreliminary').on('click', function (e, fromEOL, dontCheckEmpty) {
        gTriggerExportFormats = false;
        SendToPreliminary(e, fromEOL, dontCheckEmpty, gTriggerExportFormats);
    });

    $('input#btnSendToPreliminaryAndTriggerExportFormats').on('click', function (e, fromEOL, dontCheckEmpty) {
        gTriggerExportFormats = true;
        SendToPreliminary(e, fromEOL, dontCheckEmpty, gTriggerExportFormats);
    });

    $('input#btnSaveAndCloseFile').on('click', function (e, fromEOL, dontCheckEmpty) {
        if (screening) {
            $('span.validationAreaGeneral').hide();
            $('span.validationAreaLeft').hide();
            $('span.validationAreaRight').hide();
            if(!ValidateScreeningInputFields())
            {
                $("#screeningvalidationdiv")[0].scrollIntoView(true);
                return;
            }
            if (!noRequestForm)
            {
                if(!ValidateRequestFormInputFields(true))
                {
                    $('a[href="#requestTab"]').trigger('click');
                    $("#request #validationdiv")[0].scrollIntoView(true);
                    return;
                }
            }
        }
        //CHECK G2
        if (typeof dontCheckEmpty == "undefined") {
            dontCheckEmpty = false;
        }
        if (typeof fromEOL == "undefined") {
            fromEOL = false;
        }

        if (!fromEOL && userHasSpeechRecognition && useG2Speech && !dontCheckEmpty && !screening) {

            clearTimeout(window.pollG2Timeout);
            $('#btnValidateAndCloseFile').attr('disabled', true);
            $('#btnSaveAndCloseFile').attr('disabled', true);

            closeActiveSpeech(Model.OrderNumber).done(function (e) {

                $('#btnValidateAndCloseFile').removeAttr('disabled');
                $('#btnSaveAndCloseFile').removeAttr('disabled');

                $.ajax({
                    type: "GET",
                    url: "/legacy/Reports/GetG2SpeechDocumentOnSaveAndClose",
                    async: false,
                    data: {
                        GUID: reportGUID,
                        Order_UID: Model.OrderID
                    },
                    timeout: 15000,
                    success: function (data) {
                        clearTimeout(window.pollG2Timeout);

                        if ((data.AllOk || (data.ErrorG2 && !data.SpeechDocumentExists && $('#editableContent').val() == "true")) && $('#editableContent').val() == "false") {
                            if (data.ReportGUID)
                            {
                                reportGUID = data.ReportGUID;
                            }
                            $('#startSpeechRecognition').removeClass('disabled');
                            tinymce.activeEditor.setContent(data.Result);
                        }
                        else if (data.ErrorG2) {
                            $('#startSpeechRecognition').removeClass('disabled');
                            alert(data.ErrorMessage);
                            return false;
                        }

                        if (CheckReportContentBeforeSaving(dontCheckEmpty, 1)) {
                            if (showConfirmationOnSave) {
                                showConfirmationPopup(2);
                            }
                            else {
                                if (isAssistentRadiologist) {
                                    ShowPopupChooseSupervisor(false, true, false, false);
                                }
                                else {
                                    ValidateOrSaveAndClose(false, true, null, false, false);
                                }
                            }
                        }
                    }
                });
            }).error(function(e) {
                $('#btnValidateAndCloseFile').removeAttr('disabled');
                $('#btnSaveAndCloseFile').removeAttr('disabled');
            });

        }
        else {
            if (CheckReportContentBeforeSaving(dontCheckEmpty, 1)) {
                if (showConfirmationOnSave) {
                    showConfirmationPopup(2);
                }
                else {
                    if (isAssistentRadiologist) {
                        ShowPopupChooseSupervisor(false, true, false, false);
                    }
                    else {
                        ValidateOrSaveAndClose(false, true, null, false, false);
                    }
                }
            }
        }
        $('body').off('click', 'ul.listFound li');
    });

    $('input#btnValidateAndCloseFile').on('click', function (e, fromEOL, dontCheckEmpty) {
        if (screening) {
            $('span.validationAreaGeneral').hide();
            $('span.validationAreaLeft').hide();
            $('span.validationAreaRight').hide();
            if(!ValidateScreeningInputFields())
            {
                $("#screeningvalidationdiv")[0].scrollIntoView(true);
                return;
            }
            if (!noRequestForm)
            {
                if(!ValidateRequestFormInputFields(true))
                {
                    $('a[href="#requestTab"]').trigger('click');
                    $("#request #validationdiv")[0].scrollIntoView(true);
                    return;
                }
            }
        }
        //CHECK G2
        if (typeof dontCheckEmpty == "undefined") {
            dontCheckEmpty = false;
        }
        if (typeof fromEOL == "undefined") {
            fromEOL = false;
        }

        if (!fromEOL && userHasSpeechRecognition && useG2Speech && !dontCheckEmpty && !screening) {

            clearTimeout(window.pollG2Timeout);
            $('#btnValidateAndCloseFile').attr('disabled', true);
            $('#btnSaveAndCloseFile').attr('disabled', true);

            closeActiveSpeech(Model.OrderNumber).done(function (e) {

                $('#btnValidateAndCloseFile').removeAttr('disabled');
                $('#btnSaveAndCloseFile').removeAttr('disabled');

                $.ajax({
                    type: "GET",
                    url: "/legacy/Reports/GetG2SpeechDocumentOnSaveAndClose",
                    async: false,
                    data: {
                        GUID: reportGUID,
                        Order_UID: Model.OrderID
                    },
                    success: function (data) {
                        clearTimeout(window.pollG2Timeout);
                        if ((data.AllOk || (data.ErrorG2 && !data.SpeechDocumentExists && $('#editableContent').val() == "true")) && $('#editableContent').val() == "false") {
                            if (data.ReportGUID) {
                                reportGUID = data.ReportGUID;
                            }
                            $('#startSpeechRecognition').removeClass('disabled');
                            tinymce.activeEditor.setContent(data.Result);
                        }
                        else if (data.ErrorG2) {
                            $('#startSpeechRecognition').removeClass('disabled');
                            alert(data.ErrorMessage);
                            return false;
                        }
                        if (CheckReportContentBeforeSaving(dontCheckEmpty, 2)) {
                            if (showConfirmationOnValidate) {
                                showConfirmationPopup(1);
                            }
                            else {
                                if (isAssistentRadiologist) {
                                    ShowPopupChooseSupervisor(true, true, false, false);
                                }
                                else {
                                    if (userRadiologistId != 0 && Model.SupervisorId != null && userRadiologistId !== Model.SupervisorId) {
                                        ShowPopupSetCurrentRadiologistAsSupervisor(true, true, false, false)
                                    }
                                    else {
                                        ValidateOrSaveAndClose(true, true, null, false, false);
                                    }
                                }
                            }
                        }
                    }
                });
            }).error(function(e) {
                $('#btnValidateAndCloseFile').removeAttr('disabled');
                $('#btnSaveAndCloseFile').removeAttr('disabled');
            });

        }
        else {
            if (CheckReportContentBeforeSaving(dontCheckEmpty, 2)) {
                if (showConfirmationOnValidate) {
                    showConfirmationPopup(1);
                }
                else {
                    if (isAssistentRadiologist) {
                        ShowPopupChooseSupervisor(true, true, false, false);
                    }
                    else {
                        if (userRadiologistId != 0 && Model.SupervisorId != null && userRadiologistId !== Model.SupervisorId) {
                            ShowPopupSetCurrentRadiologistAsSupervisor(true, true, false, false)
                        }
                        else {
                            ValidateOrSaveAndClose(true, true, null, false, false);
                        }
                    }
                }
            }
        }
        $('body').off('click', 'ul.listFound li');
    });

    $('input#verifyNomenclatures').on('click', function (e) {
        showConfirmationPopup(5);
    });

    $('span.validation').hide();

    $('span.validationAreaGeneral').hide();
    $('span.validationAreaLeft').hide();
    $('span.validationAreaRight').hide();

    $('h3.panelHeaderPassive').next().hide();

    var m = moment($('span#age').html(), "DD/MM/YYYY");
    var mReportDate = moment(Model.OrderDateOfImplementation, "DD/MM/YYYY");
    if (m.isValid() && mReportDate.isValid()) {
        $('span#age').html(mReportDate.diff(m, 'years'));
    }

    $('a[href="#"]').on('click', function (e) {
        e.preventDefault();
    });

    $('select').each(function (e) {
        if ($(this).attr('value') != null) {
            $(this).val($(this).attr('value'));
        }
    });

    $('textarea').each(function (e) {
        if ($(this).attr('value') != null) {
            $(this).val($(this).attr('value'));
        }
    });

    $('#divPopupConfirmation' + viewbagUniquePrefix).dialog({
        autoOpen: false,
        resizable: false,
        position: { my: "left top", at: "left+15 top+30", of: '#contentView' },
        modal: true,
        appendTo: "#contentView"
    });

    $('#divViewReportDialog' + viewbagUniquePrefix).dialog({
        autoOpen: false,
        resizable: false,
        modal: false,
        draggable: true,
        appendTo: "#contentView",
        title: $("<div/>").html(window.Resources.Preview + ' ' + window.Resources.Report).text(),
        position: { my: "right top", at: "right-15 top+30", of: '#contentView' },
        sticky: 'false'
    });

    $('input[type=radio]').on('change', function (e) {
        var thisVal = $(this).val();
        $(this).attr('checked', true);
        $('input[type=radio][name=' + $(this).attr('name') + ']').each(function (i, y) {
            if ($(y).val() != thisVal) {
                $(y).removeAttr('checked');
            }
        });
    });

    $('input#viewHistoryPatient').on('click', function (e) {
        useFilingCabinet("/Patients/OrderHistory/" + Model.PatientID);
    });

    $('input#loadOrder').on('click', function (e) {
        useFilingCabinet("/Orders/Detail/" + Model.OrderID);
    });

    $('body').on('mouseenter', 'div#orderHistoryTimeline li ul, div#orderHistoryTimeline li.yearItem span.amount', function (e) {
        $(this).parent().addClass('hoverItem');
    });
    $('body').on('mouseleave', 'div#orderHistoryTimeline li ul, div#orderHistoryTimeline li.yearItem span.amount', function (e) {
        $(this).parent().removeClass('hoverItem');
    });

    //$('div#submitBottom').find('div#orderHistoryTimeline, div#noOrderHistoryTimeline').remove();

    $('div#contentView').show();

    var activeTimeline;

    var ToggleTimeline = function (e) {
        if (!$('#subPageContent').hasClass('loadedForToggleTimeline')) {
            $('#subPageContent').addClass('loadedForToggleTimeline');
            if (showTimelineOnBottomOfReport) {
                activeTimeline = true;
            }
            else {
                activeTimeline = false;
            }
        }

        if (activeTimeline || typeof activeTimeline == 'undefined') {
            $('#toggleTimeline' + viewbagUniquePrefix).addClass('active');
            $('#orderHistoryContainer').show();
            $('#yearHistoryContainer').show();
            $('#noOrderHistoryContainer').show();
        }
    else {
            $('#toggleTimeline' + viewbagUniquePrefix).removeClass('active');
            $('#orderHistoryContainer').hide();
            $('#yearHistoryContainer').hide();
            $('#noOrderHistoryContainer').hide();
        }

        ResizeOrderReportFields();
    };

    $('body').on('click', '#toggleTimeline' + viewbagUniquePrefix, function (e) {
        e.stopImmediatePropagation();
        e.stopPropagation();
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            activeTimeline = false;
        }
        else {
            activeTimeline = true;
        }
        ToggleTimeline();
    });

    var NoOrderHistory = function (e) {
        var divNoTimeLine = '<div id="noOrderHistoryTimeline">';
        divNoTimeLine += '<a class="toggleTimelineBtn" id="toggleTimeline' + viewbagUniquePrefix + '">HIDE/SHOW TIMELINE</a>';
        divNoTimeLine += '<div id="noOrderHistoryContainer">' + htmlDecode(window.Resources.NoOrderHistoryFound2) + '</div>';
        divNoTimeLine += '</div>';
        $('div#submitBottom').prepend(divNoTimeLine);
        var orderHistoryTab = '<div class="clearfix boxSizing" style="margin: 10px 10px 0px 10px; width: Calc(100% - 20px);">';
        orderHistoryTab += '<h3 class="insideTabHeader" style="margin-bottom: 0px !important">' + htmlDecode(window.Resources.NoOrderHistoryFound2) + '</h3>';
        orderHistoryTab += '</div>';
        $('#historyTab').html(orderHistoryTab);

        ToggleTimeline();
    }
    var scrollingOverOrders = false;

    $('body').on('click', '#backToOrderHistoryOverview', function (e) {
        e.stopImmediatePropagation();
        e.stopPropagation();
        $('div#backToOrderHistoryOverview').hide();
        $('div#historyTabPreviousReport').hide();
        $('table#orderHistoryTable').show();
        $('#filterOrderHistoryInTab').show();
    });

    var SetOrderHistory = function (FilterModality, FilterProcedures) {
        var divTimeLine = '<div id="orderHistoryTimeline">';
        divTimeLine += '<a class="toggleTimelineBtn" id="toggleTimeline' + viewbagUniquePrefix + '">HIDE/SHOW TIMELINE</a>';
        divTimeLine += '<div class="timelineContainer" id="orderHistoryContainer"><ul class="timelineList" id="orderHistoryList"></ul></div>';
        divTimeLine += '<div class="timelineContainer" id="yearHistoryContainer"><ul class="timelineList" id="yearHistoryList"></ul></div>';
        divTimeLine += '</div>';
        $('div#submitBottom').prepend(divTimeLine);

        var amountInWidth = $('.timelineContainer').width() / 200;

        var orderHistoryTab = '<div class="clearfix boxSizing" style="margin: 10px 10px 0px 10px; width: Calc(100% - 20px);">';
        orderHistoryTab += '<h3 class="insideTabHeader" style="margin-bottom: 0px !important">' + htmlDecode(window.Resources.History2) + '<span id="amountOfHistoryFound"></span></h3>';
        orderHistoryTab += '<div id="backToOrderHistoryOverview">' + htmlDecode(window.Resources.BackToOverview) + '</div>';
        orderHistoryTab += '<div id="previousReportLoading" style="text-align: center; display: none;"><img src="./Content/img/loading.gif"/></div>';
        orderHistoryTab += '<ul id="filterOrderHistoryInTab" class="clearfix">&nbsp;</ul>';
        orderHistoryTab += '<table class="regularTable boxSizing" id="orderHistoryTable" style="margin-top: 20px !important;">';
        orderHistoryTab += '<tbody>';
        orderHistoryTab += '<tr>';
        orderHistoryTab += '<th class="pr15 center">' + htmlDecode(window.Resources.Date) + '</th>';
        orderHistoryTab += '<th class="pr85">' + htmlDecode(window.Resources.Procedures) + '</th>';
        orderHistoryTab += '</tr>';

        $.each(orderHistory.Items, function (i, x) {
            var toAppend = '<li class="timelineItem ' + x.Year + '" id="fromOrderHistoryTimeLine' + (x.HasReport ? x.Report_UID : 0) + '_' + x.Order_UID + '">';
            var ulToAppend = '<ul>';
            $.each(x.OrderProcedures, function (i, proc) {
                ulToAppend += '<li class="procedureItem ' + (proc.StatusIndicator == 5 ? "controlProcedure" : (proc.StatusIndicator == 1 ? "startedProcedure" : (proc.StatusIndicator == 2 ? "finishedProcedure" : (proc.StatusIndicator == 3 ? "correctionProcedure" : (proc.StatusIndicator == 4 ? "canceledProcedure" : ""))))) + '" style="background-color: ' + proc.Color + '"';
                ulToAppend += ' title="' + proc.Modality_Text + ' - ' + proc.Description + '<br>' + proc.Room_Text + ' - <b>' + proc.Radiologist_Text + ' (R)</b> - ' + proc.Technician_Text + ' (T)">';
                ulToAppend += '<span class="hidden number">' + proc.OrderHasProcedure_UID + '</span>';
                ulToAppend += '<span class="insideProcedureItemContainer"><b>' + proc.Modality_Text + "</b> ";
                ulToAppend += proc.Code + '</span>';
                ulToAppend += '</li>';
            });
            ulToAppend += '</ul>';
            toAppend += ulToAppend;
            toAppend += '<span class="hidden orderID">' + x.Order_UID + '</span>';
            toAppend += "<span class='date'>(" + x.DateTime + ")</span>";
            toAppend += '<input type="hidden" class="orderHistoryDate" value="' + x.DateTime + '">';
            toAppend += "<span class='titlePopup hidden'>" + x.Title + " (" + x.DateTime + ")</span>";
            if (x.HasReport == true) {
                toAppend += '<span class="hidden reportID">' + x.Report_UID + '</span>';
            }
            toAppend += '<span class="reportLink link">' + $("<div/>").html(window.Resources.Open).text() + '</span>';
            toAppend += '</li>';
            $('ul#orderHistoryList').append(toAppend);

            orderHistoryTab += '<tr class="orderHistoryItem" id="fromOrderHistoryTab' + (x.HasReport ? x.Report_UID : 0) + '_' + x.Order_UID + '">';
            orderHistoryTab += '<td class="pr15 center">' + x.DateTime + '</td>';
            orderHistoryTab += '<td class="pr85">' + ulToAppend + '</td>';
            orderHistoryTab += '</tr>';
        });

        if (orderHistory.Items.length > 0) {
            orderHistoryTab += '</tbody>';
            orderHistoryTab += '</table>';
        }

        orderHistoryTab += '</div>';
        orderHistoryTab += '<div style="display: none; margin-top: 10px;" id="historyTabPreviousReport">';
        orderHistoryTab += '</div>';

        $('#historyTab').empty();
        $('#historyTab').append(orderHistoryTab);

        $('.procedureItem').tooltip({
            tooltipClass: 'jqueryTooltip',
            //track: true,
            content: function () {
                return $(this).prop('title');
            },
            position: {
                my: "left top",
                at: "left bottom"
            },
            close: function (event, ui) {
                $('.jqueryTooltip').remove();
            },
            show: function (event, ui) {
                $('.jqueryTooltip').remove();
            }
        });

        var totalWidth = 0;
        $.each($('ul#orderHistoryList li.timelineItem'), function (i, y) {
            totalWidth += $(this).outerWidth();
            if (i == $('ul#orderHistoryList li.timelineItem').length - 1) {
                totalWidth += $('div#orderHistoryContainer').width() - $(this).outerWidth();
            }
        });

        $('#orderHistoryList').css('width', totalWidth);

        var filterHistoryInTab = '<li class="filterHistory">';
        filterHistoryInTab += '<input type="checkbox" class="checkModality check-box" id="checkModalityFromTab' + $('#uniquePrefix').text() + '" ' + (FilterModality ? 'checked="true"' : '') + ' /><span>' + $('<div/>').html(window.Resources.SameModality).text() + '</span></li>';

        filterHistoryInTab += '<li class="filterHistory">';
        filterHistoryInTab += '<input type="checkbox" class="checkProcedures check-box" id="checkProceduresFromTab' + $('#uniquePrefix').text() + '" ' + (FilterProcedures ? 'checked="true"' : '') + ' /><span>' + $('<div/>').html(window.Resources.SameProcedures).text() + '</span></li>';
        $('#filterOrderHistoryInTab').append(filterHistoryInTab);

        var checkModality = '<li class="filterHistory">';
        checkModality += '<input type="checkbox" class="checkModality check-box" id="checkModality' + $('#uniquePrefix').text() + '" ' + (FilterModality ? 'checked="true"' : '') + ' /><span>' + $('<div/>').html(window.Resources.SameModality).text() + '</span></li>';
        $('ul#yearHistoryList').append(checkModality);

        var checkProcedures = '<li class="filterHistory">';
        checkProcedures += '<input type="checkbox" class="checkProcedures check-box" id="checkProcedures' + $('#uniquePrefix').text() + '" ' + (FilterProcedures ? 'checked="true"' : '') + ' /><span>' + $('<div/>').html(window.Resources.SameProcedures).text() + '</span></li>';
        $('ul#yearHistoryList').append(checkProcedures);

        var totalHistoryUnFiltered = 0;
        var totalHistoryFiltered = 0;
        $.each(orderHistory.OrdersInYears, function (i, x) {
            if (x.OriginalAmount != 0) {
                totalHistoryUnFiltered += x.OriginalAmount;
                totalHistoryFiltered += x.Amount;
                var toAppend = '<li class="yearItem">';
                if (x.Amount != x.OriginalAmount) {
                    toAppend += '<span class="title">' + x.Year + '</span><span class="amount">&nbsp;(' + x.Amount + ' ' + $("<div/>").html(window.Resources.of).text() + ' ' + x.OriginalAmount + ')</span>';
                }
                else {
                    toAppend += '<span class="title">' + x.Year + '</span><span class="amount">&nbsp;(' + x.Amount + ')</span>';
                }
                $('ul#yearHistoryList').append(toAppend);
            }
        });

        var totalHistoryFilteredAmount = ' ';
        if (totalHistoryFiltered == totalHistoryUnFiltered) {
            totalHistoryFilteredAmount += '(' + totalHistoryUnFiltered + ')';
        }
        else {
            totalHistoryFilteredAmount += '(' + totalHistoryFiltered + '/' + totalHistoryUnFiltered + ')';
        }

        $('#amountOfHistoryFound').text(totalHistoryFilteredAmount);
        $('#amountOfHistoryInTabLink').text(totalHistoryFilteredAmount);

        $("#orderHistoryContainer").mCustomScrollbar({
            horizontalScroll: true,
            theme: "dark",
            scrollButtons: {
                enable: true
            },
            mouseWheelPixels: 180,
            advanced: {
                updateOnBrowserResize: true,
                autoExpandHorizontalScroll: true
            }
        });

        $('#yearHistoryList').css('width', (150 * (orderHistory.OrdersInYears.length)) + 2 + "px");

        var GetPreviousReportRequest = function (reportID) {
            var req = $.ajax({
                type: 'GET',
                data: {
                    Report_UID: reportID,
                },
                url: '/legacy/Reports/GetReportContentByReportID',
                dataType: 'json'
            });

            return req;
        };

        var showPreviousReportInTab = function (ID) {
            var containerID = $('li#fromOrderHistoryTimeLine' + ID);
            var containerUL = containerID.find('ul').html();

            $('#historyTabPreviousReport').empty();
            $('#historyTabPreviousReport').show();
            $('#orderHistoryTable').hide();
            $('#backToOrderHistoryOverview').show();
            $('#filterOrderHistoryInTab').hide();

            var titlePopup = containerID.find('span.titlePopup').text();
            var reportID = containerID.find('span.reportID').text();
            var date = containerID.find('input.orderHistoryDate').val();

            var content = '<ul class="procedures" style="float: left; width: 100%; text-align: center;">' + containerUL + '</ul>';
            if (reportID != "") {
                var reqPrvRep = GetPreviousReportRequest(reportID).done(function () {
                    $('#previousReportLoading').hide();

                    var data = reqPrvRep.responseJSON;

                    if (data.AllOk == true) {

                        content += '<div id="previousReportContainerInTab">';
                        if (data.NotFound == true) {
                            content += '<span class="reportPopupInfo">' + htmlDecode(data.Content) + '</span>';
                        }
                        else if (data.Screening == true) {
                            content += '<div class="screening small">' + htmlDecode(data.Content) + '</div>';
                        }
                        else {
                            content += '<p style="float: left; width: Calc(100% - 20px); padding: 10px;">' + htmlDecode(data.Content) + '</p>';
                        }

                        if (!Model.Validated && !Model.ReadOnly && !data.Screening) {
                            //<!-- begin copy functionality -->
                            content += '<textarea id="hiddenContent" style="display:none;">' + data.Content + '</textarea>';
                            content += '<input type="button" class="button clearfix btnCopyPreviousReport" value="' + htmlDecode(window.Resources.CopyToCurrentReport) + '" title="' + htmlDecode(window.Resources.CopyToCurrentReport) + '" />';
                            content += '<input type="button" class="button clearfix btnCopyPreviousReportToG2" value="' + htmlDecode(window.Resources.CopyToG2) + '" title="' + htmlDecode(window.Resources.CopyToG2) + '" />';
                            content += '<script type="text/javascript">';
                            content += '$("#previousReportContainerInTab .btnCopyPreviousReport").on("click", function (e) {';
                            content += 'e.stopImmediatePropagation();';
                            content += 'e.stopPropagation();';
                            content += 'var text = $(this).parent().find("textarea#hiddenContent").val();';
                            content += 'tinymce.activeEditor.focus();';
                            content += 'tinyMCE.activeEditor.execCommand("mceInsertContent", false, text);'
                            content += '});';
                            content += 'if ($("#getSpeechRecognitionText").length <= 0) {';
                            content += '$(".btnCopyPreviousReportToG2").hide();';
                            content += '}';
                            content += "<\/script>";
                            //<!-- end copy functionality -->
                        }
                        content += '</div>'
                    }
                    content += '<div id="previousReportInfoInTab">';

                    content += '<p style="margin: 5px 0px 2px 2px; font-size: 10px; float: right; width: Calc(50% - 5px);" class="backBlack boxSizing">' + htmlDecode(window.Resources.Implementation) + ': <b>' + date.replace('(', '').replace(')', '') + '</b></p>';

                    if (data.DictatedBy != "") {
                        content += '<p style="margin: 5px 0px 2px 2px; font-size: 10px; float: left; width: Calc(50% - 5px);" class="backGreen boxSizing">' + htmlDecode(window.Resources.DictatedBy) + ' <span class="bold">' + data.DictatedBy + '</span>';
                        if (data.DictatedDateTime != "") {
                            var m = moment(data.DictatedDateTime, "MM/DD/YYYY hh:mm:ss A");
                            if (m.isValid()) {
                                content += ' <span class="datetime">' + htmlDecode(m.calendar()) + '</span>';
                            }
                        }
                        content += '</p>';
                    }
                    else {
                        content += '<p style="margin: 5px 0px 2px 2px; font-size: 10px; float: left; width: Calc(50% - 5px);" class="backRed boxSizing"><span>' + htmlDecode(window.Resources.NotYetDictated) + '</span></p>';
                    }
                    if (data.ValidatedBy != "") {
                        content += '<p style="margin: 0px 0px 2px 2px; font-size: 10px; float: left; width: Calc(50% - 5px);" class="backGreen boxSizing">' + htmlDecode(window.Resources.ValidatedBy) + ' <span class="bold">' + data.ValidatedBy + '</span>';
                        if (data.ValidatedDateTime != "") {
                            var m = moment(data.ValidatedDateTime, "MM/DD/YYYY hh:mm:ss A");
                            if (m.isValid()) {
                                content += ' <span class="datetime">' + htmlDecode(m.calendar()) + '</span>';
                            }
                        }
                        content += '</p>';
                    }
                    else {
                        content += '<p style="margin: 0px 0px 2px 2px; font-size: 10px; float: left; width: Calc(50% - 5px);" class="backRed boxSizing"><span>' + htmlDecode(window.Resources.NotYetValidated) + '</span></p>';
                    }

                    if (data.HasSupervisor) {
                        content += '<p style="margin: 0px 0px 2px 2px; font-size: 10px; float: right; width: Calc(50% - 5px);" class="backBlack boxSizing">' + htmlDecode(window.Resources.Supervisor) + ' <span class="bold">' + data.SupervisorName + '</span></p>';
                    }

                    content += '</div>';

                    $('#historyTabPreviousReport').append(content);

                    $('#historyTabPreviousReport .procedureItem').tooltip({
                        tooltipClass: 'jqueryTooltip',
                        //track: true,
                        content: function () {
                            return $(this).prop('title');
                        },
                        position: {
                            my: "left top",
                            at: "left bottom"
                        },
                        close: function (event, ui) {
                            $('.jqueryTooltip').remove();
                        },
                        show: function (event, ui) {
                            $('.jqueryTooltip').remove();
                        }
                    });

                    ResizeOrderReportFields();
                });
            }
            else {
                $('#previousReportLoading').hide();

                content += '<div id="previousReportContainerInTab">';
                content += '<span class="reportPopupInfo">' + window.Resources.InfoReportNotAvailableForOrder + '</span>';
                content += '</div>';
                content += '<div id="previousReportInfoInTab">';
                content += '<p style="margin: 5px 0px 2px 2px; font-size: 10px; float: right; width: Calc(50% - 5px);" class="backBlack boxSizing">' + htmlDecode(window.Resources.Implementation) + ': <b>' + date.replace('(', '').replace(')', '') + '</b></p>';
                content += '<p style="margin: 5px 0px 2px 2px; font-size: 10px; float: left; width: Calc(50% - 5px);" class="backRed boxSizing"><span>' + htmlDecode(window.Resources.NotYetDictated) + '</span></p>';
                content += '<p style="margin: 0px 0px 2px 2px; font-size: 10px; float: left; width: Calc(50% - 5px);" class="backRed boxSizing"><span>' + htmlDecode(window.Resources.NotYetValidated) + '</span></p>';
                content += '</div>';

                $('#historyTabPreviousReport').append(content);

                $('#historyTabPreviousReport .procedureItem').tooltip({
                    tooltipClass: 'jqueryTooltip',
                    //track: true,
                    content: function () {
                        return $(this).prop('title');
                    },
                    position: {
                        my: "left top",
                        at: "left bottom"
                    },
                    close: function (event, ui) {
                        $('.jqueryTooltip').remove();
                    },
                    show: function (event, ui) {
                        $('.jqueryTooltip').remove();
                    }
                });

                ResizeOrderReportFields();
            }

            tinymce.activeEditor.focus();
        };

        $('body').on('click', 'tr.orderHistoryItem', function (e) {
            e.stopImmediatePropagation();
            e.stopPropagation();

            var reportFromOrder = $(this).attr('id').replace('fromOrderHistoryTab', '');
            showPreviousReportInTab(reportFromOrder);

            $('div#backToOrderHistoryOverview').show();
            $('div#historyTabPreviousReport').show();
            $('table#orderHistoryTable').hide();
            $('#filterOrderHistoryInTab').hide();
        });


        var hoverIntented;
        $('li.timelineItem ul li').hoverIntent(
            {
                sensitivity: 3,
                interval: 500,
                timeout: 0,
                over: function (e) {
                    e.stopImmediatePropagation();
                    e.stopPropagation();

                    if (!scrollingOverOrders) {
                        hoverIntented = $(this);
                        $('#previousReportLoading').show();
                        $('a[href="#historyTab"]').trigger('click');
                        showPreviousReportInTab($(this).parent().parent().attr('id').replace('fromOrderHistoryTimeLine', ''));
                    }
                },
                out: function (e) {
                    var hoveredTitle = hoverIntented.attr('title');
                    if (hoveredTitle != null) {
                        var hovered = $('#historyTabPreviousReport').find('li.procedureItem[title=""]');
                        hovered.attr('title', hoveredTitle);

                        $('#historyTabPreviousReport .procedureItem').tooltip({
                            tooltipClass: 'jqueryTooltip',
                            //track: true,
                            content: function () {
                                return $(this).prop('title');
                            },
                            position: {
                                my: "left top",
                                at: "left bottom"
                            },
                            close: function (event, ui) {
                                $('.jqueryTooltip').remove();
                            },
                            show: function (event, ui) {
                                $('.jqueryTooltip').remove();
                            }
                        });
                    }

                }
            }
        );

        ToggleTimeline();
    }

    $('body').on('click', 'li.filterHistory', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();

        var chkBox;

        if ($(e.target).hasClass('check-box')) {
            return false;
        }
        else {
            chkBox = $(this).find('input[type=checkbox]');
        }

        chkBox.prop("checked", !chkBox.prop("checked"));
        chkBox.attr("checked", chkBox.prop('checked'));

        if (chkBox.hasClass('checkProcedures')) {
            $('input.checkProcedures').prop('checked', chkBox.prop('checked'));
        }
        else if (chkBox.hasClass('checkModality')) {
            $('input.checkModality').prop('checked', chkBox.prop('checked'));
        }

        GetOrderHistory();
    });

    $('body').on('click', 'li.filterHistory input.check-box', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();

        var chkBox = $(this);

        if (chkBox.hasClass('checkProcedures')) {
            $('input.checkProcedures').prop('checked', chkBox.prop('checked'));
        }
        else if (chkBox.hasClass('checkModality')) {
            $('input.checkModality').prop('checked', chkBox.prop('checked'));
        }

        GetOrderHistory();
    });

    $('body').on('click', 'li.yearItem', function (e) {
        e.stopImmediatePropagation();
        var year = $(this).find('span.title').text();
        var firstOfYear = $('ul#orderHistoryList').find('li.' + year).first();
        if (firstOfYear.length !== 0) {
            var offset = firstOfYear[0].offsetLeft;
            $("#orderHistoryContainer").mCustomScrollbar("scrollTo", offset);

        }
    });

    $('body').on('click', 'li.timelineItem span.reportLink', function (e) {
        e.stopImmediatePropagation();
        var orderID = $(this).parent().find('span.orderID').text();
        if (orderID != "") {
            useFilingCabinet("/Reports/OrderDetail/" + orderID);
        }
    });

    var orderHistory;
    var orderHistoryFound = false;

    var OrderHistoryCall = function (FilterModality, FilterProcedures) {
        var req = $.ajax({
            type: 'GET',
            //async: false,
            data: {
                Patient_UID: Model.PatientID,
                Order_UID: Model.OrderID,
                CheckedFilterModality: FilterModality,
                CheckedFilterProcedure: FilterProcedures,
                Partial: false,
                PartialReport_UID: viewbagreport_UID,
                PartialProcedure_IDs: forOrder_ProcedureUIDs
            },
            url: '/legacy/Reports/GetOrderHistoryTimeLine',
            dataType: 'json'
        });

        return req;
    };

    var GetOrderHistory = function (e) {
        orderHistory = null;
        orderHistoryFound = false;
        $('ul#orderHistoryList').hide();
        var loader = $('<div><img src="/Content/img/loading.gif"/></div>');
        $('div#orderHistoryContainer').prepend(loader);

        var historyErrors = false;

        var chkBxMod = $('#checkModality' + $('#uniquePrefix').text());
        var chkBxProc = $('#checkProcedures' + $('#uniquePrefix').text());

        var CheckedFilterModality = chkBxMod.length ? $('#checkModality' + $('#uniquePrefix').text()).prop('checked') : filterReportHistoryModality;
        var CheckedFilterProcedures = chkBxProc.length ? $('#checkProcedures' + $('#uniquePrefix').text()).prop('checked') : filterReportHistoryProcedures;

        var reqHis = OrderHistoryCall(CheckedFilterModality, CheckedFilterProcedures).done(function () {
            if (reqHis.responseJSON.AllOk) {
                orderHistoryFound = true;
                orderHistory = reqHis.responseJSON.OrderHistory;
            }
            else {
                historyErrors = true;
            }

            $('#orderHistoryTimeline').remove();
            $('#noOrderHistoryTimeline').remove();

            if (orderHistoryFound) {
                if (historyErrors) {
                    NoOrderHistory();
                }
                else {
                    SetOrderHistory(CheckedFilterModality, CheckedFilterProcedures);
                }
            }
            else {
                NoOrderHistory();
            }
            $('ul#orderHistoryList').show();
            ResizeOrderReportFields();
        });
    }

    GetOrderHistory();

    var startDragg = 0;
    $('body').on('mousedown', '#orderHistoryTimeline #orderHistoryContainer', function (e) {
        scrollingOverOrders = true;
        try {
            startDragg = -mcs.left;
        } catch (e) { }
        e.preventDefault();
        $(this)
            .data('down', true) // a flag indicating the mouse is down
            .data('x', e.clientX) // the current mouse down X coord
            .data('scrollLeft', this.scrollLeft); // the current scroll position
        return false;
    });

    $('body').on('mousedown', '#orderHistoryTimeline #yearHistoryContainer', function (e) {
        e.preventDefault();
        $(this)
            .data('down', true) // a flag indicating the mouse is down
            .data('x', e.clientX) // the current mouse down X coord
            .data('scrollLeft', this.scrollLeft); // the current scroll position
        return false;
    });

    $('body').on('mouseup', function (e) {
        var containerOrders = $('#orderHistoryTimeline #orderHistoryContainer');
        $(containerOrders).data('down', false);
        scrollingOverOrders = false;
        var containerYears = $('#orderHistoryTimeline #yearHistoryContainer');
        $(containerYears).data('down', false);
    });

    $('body').on('mousemove', function (e) {
        var containerOrders = $('#orderHistoryTimeline #orderHistoryContainer');
        if (containerOrders.data('down') == true) {
            $("#orderHistoryContainer").mCustomScrollbar("scrollTo", startDragg + (containerOrders.data('x') - e.clientX),{
                scrollInertia: 10
            });
        }
        var containerYears = $('#orderHistoryTimeline #yearHistoryContainer');
        if (containerYears.data('down') == true) {
            containerYears[0].scrollLeft = containerYears.data('scrollLeft') + containerYears.data('x') - e.clientX;
        }
    });


    //Firefox
    $('#orderHistoryTimeline #orderHistoryContainer').bind('DOMMouseScroll', function (e) {
        if (e.originalEvent.detail > 0) {
            ScrollRightOrders();
        } else {
            ScrollLeftOrders();
        }
        return false;
    });
    $('#orderHistoryTimeline #yearHistoryContainer').bind('DOMMouseScroll', function (e) {
        if (e.originalEvent.detail > 0) {
            ScrollRightYears();
        } else {
            ScrollLeftYears();
        }
        return false;
    });

    var ScrollLeftOrders = function (e) {
        try {
            $("#orderHistoryContainer").mCustomScrollbar("scrollTo", "-=180", {
                scrollInertia: 10
            });
        }
        catch (e) {}
    }
    var ScrollLeftYears = function (e) {
        $("#orderHistoryTimeline #yearHistoryContainer").finish();
        $("#orderHistoryTimeline #yearHistoryContainer").animate({
            scrollLeft: "-=150"
        }, 450);
    }

    var ScrollRightOrders = function (e) {
        try  {
            $("#orderHistoryContainer").mCustomScrollbar("scrollTo", "+=180", {
                scrollInertia: 10
            });
        }
        catch (e) { }
    }
    var ScrollRightYears = function (e) {
        $("#orderHistoryTimeline #yearHistoryContainer").finish();
        $("#orderHistoryTimeline #yearHistoryContainer").animate({
            scrollLeft: "+=150"
        }, 450);
    }

    setTimeout(function () {
        if ($('div#subContent').find('div#submitBottom').length > 0) {
            $('div#subPageContent').height($('div#content').height() - 20 - $('div#submitBottom').height());
        }
        //ResizeTopSubField();
        $("#orderHistoryContainer").mCustomScrollbar("update");
    }, 300);

    $('#loading').hide();

    $(window).resize(function (e) {
        setTimeout(function (e) {
            $("#orderHistoryContainer").mCustomScrollbar("update");
        }, 300);
    });

    $('div.productsInReport').on('click', function (e) {
        e.stopImmediatePropagation();
        e.stopPropagation();
        $('li#openProductsTab a').trigger('click');
    });

    $('input#printTempReport').on('click', function (e) {
        e.stopImmediatePropagation();
        e.stopPropagation();

        var reportContent = $('textarea#ReportContent').attr('value').replace(/\r?\n/g, '<br>');

        $.ajax({
            type: 'POST',
            data: {
                OrderID: Model.OrderID,
                ReportContent: reportContent
            },
            url: '/legacy/Reports/PrintTempReport',
            dataType: 'json',
            success: function (data) {
                if (data.AllOk != true) {
                    alert("Printing failed!");
                }
            }
        });
    });

    //CHECKS

    var CheckReportDictatedForChecks = function (orderID) {
        var allChecked = true;
        $.ajax({
            type: "GET",
            url: "/legacy/Orders/CheckDictatedChecks",
            async: false,
            data: {
                Order_UID: orderID
            },
            success: function (data) {
                if (data.AllOk) {
                    allChecked = data.AllChecked;

                    if (data.Checks.length != 0 && !data.AllChecked) {
                        $('#checksTable tr.checkRecord').remove();
                        $('#extraInformationChecks').empty();

                        $.each(data.Checks, function (i, check) {
                            $('#checksTable').append(createCheckRow(check));
                        });
                        $('#GroupChecks').prop("checked", false);
                        checkCheckGrouping();
                        $('#divPopupConfirmationChecksRemaining').find('span.validation').hide();
                        $('#divPopupConfirmationChecksRemaining').dialog('open');
                    }
                }
                else {
                    if (data.Error) {
                        console.log('Error checking dictated checks: ' + data.Message);
                    }
                }
            }
        });
        return allChecked;
    }

    $('#btnSaveChecks').on('click', function (e) {
        //check if all obligatory checks are set
        checkModels = [];

        var allObligatoryChecked = true;
        $('#checksTable tr.checkRecord').each(function (i, row) {
            // reference all the stuff you need first
            var row = $(row);
            var checked = row.find('input.checkChecked').is(':checked');
            var obligatory = row.find('input.obligatory').val() == 'true';
            var obligatoryForStatus = row.find('input.requiredToChangeToStatusStatus').val();
            var remark = row.find('textarea.checkremarkText').text();

            var checkModel = {
                Entity_HasCheck_UID: row.find('input.checkGUID').val(),
                Checked: row.find('input.checkChecked').is(':checked'),
                Unit: row.find('input.unitValue').val(),
                TextValue: row.find('input.textValue').val(),
                TextValue2: row.find('input.textValue2').val(),
                DateValue: row.find('input.dateValue').val(),
                DropDownValue: row.find('select.dropdownValue').find(':selected').val(),
                CheckedBy_UID: row.find('input.checkByUID').val(),
                Check_UID: row.find('input.checkUID').val(),
                CheckRemarks: row.find('textarea.checkremarkText').text(),
                IsGrouped: row.find('input.isGrouped').val(),
                IsGroupMaster: row.find('input.isGroupMaster').val(),
                IsGroupSlave: row.find('input.isGroupSlave').val(),
                RoomUID: row.find('input.roomUID').val(),
                RoomText: row.find('input.roomText').val()
            };
            checkModels.push(checkModel);

            if((checkModel.IsGrouped == 'true' && checkModel.IsGroupMaster == 'true') || checkModel.IsGrouped == 'false')
            {
                //only check when the record is a Master or there is no grouping at all
                if ((!checked && obligatory) && ($.trim(remark) == "" && obligatory) && 5 >= obligatoryForStatus) {
                    allObligatoryChecked = false;
                }
            }

        });
        if (!allObligatoryChecked) {
            //give error
            $('#divPopupConfirmationChecksRemaining').find('span.validation').show();
            $('#divPopupConfirmationChecksRemaining').find('span.validation').text(window.ErrorStrings.CheckAllChecks);
        }
        else {
            UpdateChecks();
            $('#divPopupConfirmationChecksRemaining').dialog('close');
            ValidateOrSaveAndCloseFunctionality(gValidated, gClose, gSupervisor_uid, gTranscription, gPreliminary, gTriggerExportFormats);
        }
    });

    var UpdateChecks = function (e) {
        $.ajax({
            url: "/legacy/Json/UpdateChecksForOrder",
            type: "POST",
            dataType: "json",
            traditional: true,
            data: {
                Checks: JSON.stringify(checkModels)
            },
            success: function (data) {
                if (data.Error) {
                    alert('Error updating checks: ' + data.Message);
                }
            }
        });
        checkModels = [];
    }

    var createCheckRow = function (ch) {
        var rowToAppend = $('<tr class="record' + ch.Entity_HasCheck_UID + ' checkRecord"></tr>');
        var cellsToAppend;

        cellsToAppend += '<td class="center pr5 center checkbox">';
        if (ch.Checked) {
            cellsToAppend += '<input type="checkbox" class="checkChecked check-box" checked="checked" name="Checks[0].Checked" value="true" />';
        }
        else {
            cellsToAppend += '<input type="checkbox" class="checkChecked check-box" name="Checks[0].Checked" />';
        }

        cellsToAppend += '<input type="hidden" class="checkGUID" name="Checks[0].GUID" value="' + ch.Entity_HasCheck_UID + '" />';
        cellsToAppend += '<input type="hidden" class="obligatory" name="Checks[0].Obligatory" value="' + ch.Obligatory + '" />';
        cellsToAppend += '<input type="hidden" class="requiredToChangeToStatus" name="Checks[0].CheckRequiredToChangeToStatus" value="' + ch.CheckRequiredToChangeToStatus + '" />';
        cellsToAppend += '<input type="hidden" class="requiredToChangeToStatusStatus" name="Checks[0].CheckRequiredToChangeToStatusStatus" value="' + ch.CheckRequiredToChangeToStatusStatus + '" />';
        cellsToAppend += '<input type="hidden" class="isGrouped" name="Checks[0].IsGrouped" value="' + ch.IsGrouped + '" />';
        cellsToAppend += '<input type="hidden" class="isGroupMaster" name="Checks[0].IsGroupMaster" value="' + ch.IsGroupMaster + '" />';
        cellsToAppend += '<input type="hidden" class="isGroupSlave" name="Checks[0].IsGroupSlave" value="' + ch.IsGroupSlave + '" />';
        cellsToAppend += '<input type="hidden" class="roomUID" name="Checks[0].RoomUID" value="' + ch.RoomUID + '" />';
        cellsToAppend += '<input type="hidden" class="roomText" name="Checks[0].RoomText" value="' + ch.RoomText + '" />';
        cellsToAppend += '</td>';
        cellsToAppend += '<td class="pr20 checkName" title="' + ch.CheckDescription + '">';
        cellsToAppend += ch.CheckName;
        cellsToAppend += '<input type="hidden" class="checkName" readonly="readonly" name="Checks[0].CheckName" value="' + ch.CheckName + '" />';
        cellsToAppend += '<input type="hidden" class="checkDescription" name="Checks[0].CheckDescription" value="' + ch.CheckDescription + '" />';
        cellsToAppend += '<input type="hidden" class="checkUID" name="Checks[0].Check_UID" value="' + ch.Check_UID + '" />';
        cellsToAppend += '</td>';
        cellsToAppend += '<td class="pr40">';
        cellsToAppend += '<input type="hidden" class="checkType" name="Checks[0].TypeCode" value="' + ch.TypeCode + '" />';
        switch (ch.TypeCode) {
            case "DDL":
                cellsToAppend += '<select class="dropdownValue">';
                $.each(ch.DropDownChoices, function (i, choice) {
                    cellsToAppend += '<option value="' + choice.Value + '">' + choice.Text + '</option>';
                });
                cellsToAppend += '</select>';
                break;
            case "FU":
                cellsToAppend += '<input class="textValue" name="Checks[0].TextValue" type="text" value="' + ch.TextValue + '">';
                cellsToAppend += '<input class="unitValue" disabled name="Checks[0].Unit" type="text" value="' + ch.Unit + '">';
                break;
            case "FUD":
                cellsToAppend += '<input class="textValue" name="Checks[0].TextValue" type="text" value="' + ch.TextValue + '">';
                cellsToAppend += '<input class="unitValue" disabled name="Checks[0].Unit" type="text" value="' + ch.Unit + '">';
                cellsToAppend += '<input class="dateValue" placeholder="dd/mm/yyyy" name="Checks[0].DateValue" type="text" value="' + ch.DateValue + '">';
                break;
            case "FUF":
                cellsToAppend += '<input class="textValue" name="Checks[0].TextValue" type="text" value="' + ch.TextValue + '">';
                cellsToAppend += '<input class="unitValue" disabled name="Checks[0].Unit" type="text" value="' + ch.Unit + '">';
                cellsToAppend += '<input class="textValue2" name="Checks[0].TextValue2" type="text" value="' + ch.TextValue2 + '">';
                break;
        }
        cellsToAppend += '</td>';

        cellsToAppend += '<td class="pr15 checkedBy">';
        cellsToAppend += '<input type="text" class="checkByText" readonly="readonly" name="Checks[0].CheckedBy" value="' + ch.CheckedBy + '" />';
        cellsToAppend += '<input type="hidden" class="checkByUID" name="Checks[0].CheckedBy_UID" value="' + ch.CheckedBy_UID + '" />';
        cellsToAppend += '</td>';
        cellsToAppend += '<td class="pr5 editRemark">';
        cellsToAppend += '<input type="hidden" class="checkremarkUID" name="Checks[0].CheckRemark_UID" value="' + ch.Entity_HasCheck_UID + '">&nbsp;';
        cellsToAppend += '<input type="hidden" class="checkremarkCopyToPatient" name="Checks[0].CopyCheckRemarksToPatient" value="' + ch.CopyCheckRemarksToPatient + '">&nbsp;';
        cellsToAppend += '<input type="hidden" class="checkremarkCopyToOrder" name="Checks[0].CopyCheckRemarksToOrder" value="' + ch.CopyCheckRemarksToOrder + '">&nbsp;';
        cellsToAppend += '<textarea class="text-box clearfix checkremarkText" name="Checks[0].CheckRemarks" value="" cols="30" rows="5" style="display:none">';
        cellsToAppend += ch.CheckRemarks;
        cellsToAppend += '</textarea>';
        cellsToAppend += '</td>';
        if (ch.FromProcedureCode != null) {
            cellsToAppend += '<td class="pr10 center fromProcedure" style="background-color: ' + ch.FromProcedureColor + ';" title="' + ch.FromProcedureDescription + '">';
            cellsToAppend += '<span class="fromProcedureInfo"><b>' + ch.FromProcedureModality + '</b> <span>' + ch.FromProcedureCode + '</span></span>';
            cellsToAppend += '<input type="hidden" class="checkFromProcedureUID" name="Checks[0].FromProcedure_UID" value="' + ch.FromProcedure_UID + '" />';
            cellsToAppend += '<input type="hidden" class="checkFromProcedureModality" name="Checks[0].FromProcedureModality" value="' + ch.FromProcedureModality + '" />';
            cellsToAppend += '<input type="hidden" class="checkFromProcedureCode" name="Checks[0].FromProcedureCode" value="' + ch.FromProcedureCode + '" />';
            cellsToAppend += '<input type="hidden" class="checkFromProcedureColor" name="Checks[0].FromProcedureColor" value="' + ch.FromProcedureColor + '" />';
            cellsToAppend += '<input type="hidden" class="checkFromProcedureDescription" name="Checks[0].FromProcedureDescription" value="' + ch.FromProcedureDescription + '" />';
            cellsToAppend += '</td>';
        }
        else {
            cellsToAppend += '<td class="pr10 center">&nbsp;</td>';
        }

        rowToAppend.html(cellsToAppend);

        return rowToAppend;
    }

    var checkCheckGrouping = function (e) {
        var isGrouped = false;

        $('#checksTable tr').each(function (i, row) {
            var row = $(row);
            var checkModel = {
                IsGrouped: row.find('input.isGrouped').val()
            };

            if (checkModel.IsGrouped == "true") {
                isGrouped = true;
                return false;
            }
        });
        if (isGrouped) {
            $('#GroupChecks').trigger('click');
        }
    }

    $('button#btnCloseSetCheckedBy').on('click', function (e) {
        $('#divSetCheckedBy').dialog("close");

        var forcheck = $('#forCheckSetBy').val();
        $('tr.record' + forcheck + ' input.checkChecked').attr('checked', '');
        $('tr.record' + forcheck + ' input.checkChecked').prop('checked', false);
        $('tr.record' + forcheck + ' input.checkChecked').val(false);
    });

    $('button#btnSaveAndCloseSetCheckedBy').on('click', function (e) {
        var forcheck = $('#forCheckSetBy').val();

        var divHolder = $('#divSetCheckedBy');
        var validation = divHolder.find('span.validation');

        var user = $('#divSetCheckedBy #setCheckedByUser').val();
        var useruid = $('#divSetCheckedBy #setCheckedByUserUID').val();

        if ($.trim(user) == "" || $.trim(useruid) == "") {
            validation.show();
            validation.text(window.ErrorStrings.ErrorSelectUser);
            return false;
        }

        $('tr.record' + forcheck + ' input.checkChecked').attr('checked', 'checked');
        $('tr.record' + forcheck + ' input.checkChecked').prop('checked', true);
        $('tr.record' + forcheck + ' input.checkChecked').val(true);

        $('tr.record' + forcheck + ' input.checkByText').val(user);
        $('tr.record' + forcheck + ' input.checkByUID').val(useruid);

        window.ChecksDialog.leavechecked = true;

        $('#divSetCheckedBy').dialog("close");

    });

    $('input#setCheckedByUser').autocomplete({
        autoFocus: true,
        source: function (request, response) {
            $.ajax({
                url: "/legacy/Json/AutoCompleteUsers",
                type: "GET",
                dataType: "json",
                data: {
                    term: request.term
                },
                success: function (data) {
                    response($.map(data, function (item) {
                        return {
                            label: item.FullText,
                            value: item.FullText,
                            id: item.ID
                        };
                    }))
                }
            })
        },
        minLength: 0,
        select: function (event, ui) {
            $(this).parent().find('#setCheckedByUserUID').val(ui.item.id);
            $(this).parent().find('#setCheckedByUser').attr('value', ui.item.value);
        }
    });

    $('body').on('click', '#checksTable td.editRemark', function (e) {
        e.stopImmediatePropagation();
        if (!$('div#subPageContent').hasClass('disabled')) {
            var forchecked = $(this).find('.checkremarkUID').val();
            var remark = $(this).find('.checkremarkText').text();

            $('#divSetRemarks').find('#forCheckRemark').val(forchecked);

            $('#divSetRemarks #setRemark').val(remark);

            $('#divSetRemarks').find('span.validation').hide();

            $.ajax({
                type: "GET",
                url: '/legacy/System/GetLoggedInUser',
                data: {},
                dataType: 'json',
                async: false,
                success: function (data) {
                    if (data.AllOk) {
                        $('#divSetRemarks').find('#setRemarkByUser').val(data.Username);
                        $('#divSetRemarks').find('#setRemarkByUser').attr('value', data.Username);
                        $('#divSetRemarks').find('#setRemarkByUserUID').val(data.UserUID);
                        $('#divSetRemarks').find('#setRemarkByUserUID').attr('value', data.UserUID);
                    }
                }
            });

            $('#divSetRemarks').dialog("open");
        }
    });
    $('#btnSaveAndCloseSetRemark').on('click', function (e) {
        e.stopImmediatePropagation();
        var forcheck = $('#forCheckRemark').val();

        var divHolder = $('#divSetRemarks');
        var validation = divHolder.find('span.validation');

        var remark = $('#divSetRemarks #setRemark').val();

        $('tr.record' + forcheck + ' textarea.checkremarkText').text(remark);

        var user = $('#divSetRemarks #setRemarkByUser').val();
        var useruid = $('#divSetRemarks #setRemarkByUserUID').val();

        if ($.trim(user) == "" || $.trim(useruid) == "") {
            validation.show();
            validation.text(window.ErrorStrings.ErrorSelectUser);
            return false;
        }

        if ($.trim(remark) == "" && !$('tr.record' + forcheck + ' input.checkChecked').is(':checked')) {
            $('tr.record' + forcheck + ' input.checkByText').val("");
            $('tr.record' + forcheck + ' input.checkByUID').val(0);
        }
        else {
            $('tr.record' + forcheck + ' input.checkByText').val(user);
            $('tr.record' + forcheck + ' input.checkByUID').val(useruid);
        }

        var copytoorder = $('tr.record' + forcheck + ' input.checkremarkCopyToOrder').val() == 'True';
        var copytopatient = $('tr.record' + forcheck + ' input.checkremarkCopyToPatient').val() == 'True';

        if (copytoorder) {
            $('textarea#Remarks').val($('textarea#Remarks').val() + '<br />' + remark);
        }
        if (copytopatient) {
            $('div#remarksDiv div.patientRemarksHolder span.publicRemarks').text($('div#remarksDiv div.patientRemarksHolder span.publicRemarks').text() + '<br />' + remark);
        }

        $('#divSetRemarks').dialog("close");
    });

    $('button#btnCloseSetRemark').on('click', function (e) {
        $('#divSetRemarks').dialog("close");
    });

    //GROUPING
    var roomHasCheckTypes = {};

    var groupChecks = function (e) {
        var rooms = [];
        //Group the checks on hall
        $('#checksTable tr').each(function (i, row) {
            var row = $(row);
            var checkModel = buildCheckModelForRow(row);

            //Not yet grouped
            if ($.inArray(checkModel.Room_UID, rooms) != -1) {
                //room already in groups
                var checkTypes = roomHasCheckTypes[checkModel.Room_UID];

                if (typeof checkTypes === 'undefined') {
                    //possible when postback on edit
                    checkTypes = [];
                }

                if ($.inArray(checkModel.Check_UID, checkTypes) != -1) {
                    //Check already has a groupMaster, make row a slave
                    row.hide();
                    //set grouped
                    row.find('input.isGrouped').val(true);
                    row.find('input.isGroupMaster').val(false);
                    row.find('input.isGroupSlave').val(true);
                }
                else {
                    //Make row a groupMaster
                    checkTypes.push(checkModel.Check_UID);
                    roomHasCheckTypes[checkModel.Room_UID] = checkTypes;

                    //set roomname
                    row.find('td.fromProcedure').removeAttr('style');
                    row.find('span.fromProcedureInfo').empty();
                    row.find('span.fromProcedureInfo').append('<span>' + checkModel.Room_Text + '</span>');

                    //set grouped
                    row.find('input.isGrouped').val(true);
                    row.find('input.isGroupMaster').val(true);
                    row.find('input.isGroupSlave').val(false);
                }
            }
            else {
                //new room
                var checkTypes = [];
                //Make row a groupMaster

                checkTypes.push(checkModel.Check_UID);
                roomHasCheckTypes[checkModel.Room_UID] = checkTypes;

                //set roomname
                row.find('td.fromProcedure').removeAttr('style');
                row.find('span.fromProcedureInfo').empty();
                row.find('span.fromProcedureInfo').append('<span>' + checkModel.Room_Text + '</span>');

                //set grouped
                row.find('input.isGrouped').val(true);
                row.find('input.isGroupMaster').val(true);
                row.find('input.isGroupSlave').val(false);

                rooms.push(checkModel.Room_UID);
            }
        });
    }

    var deGroupChecks = function (e) {
        rooms = [];
        roomHasCheckTypes = {};

        //Degroup the checks, so all of them are individualy shown
        $('#checksTable tr').each(function (i, row) {
            var row = $(row);
            var checkModel = buildCheckModelForRow(row);
            //degroup
            row.show();

            if (checkModel.IsGroupMaster) {
                //set the procedurename instead of the roomname
                row.find('td.fromProcedure').css("background-color", checkModel.FromProcedure_Color);
                row.find('span.fromProcedureInfo').empty();
                row.find('span.fromProcedureInfo').append('<span><b>' + checkModel.FromProcedure_Modality + '</b> ' + checkModel.FromProcedure_Code + '</span>');
            }

            //set grouped
            row.find('input.isGrouped').val(false);
            row.find('input.isGroupMaster').val(false);
            row.find('input.isGroupSlave').val(false);

        });
    }

    $('#GroupChecks').on('change', function () {
        if ($(this).is(':checked')) {
            groupChecks();
        }
        else {
            deGroupChecks();
        }
    });

    var checkCheckGrouping = function (e) {
        var isGrouped = false;

        $('#checksTable tr').each(function (i, row) {
            var row = $(row);
            var checkModel = {
                IsGrouped: row.find('input.isGrouped').val()
            };

            if (checkModel.IsGrouped == "true") {
                isGrouped = true;
                return false;
            }
        });
        if (isGrouped) {
            $('#GroupChecks').trigger('click');
        }
    }
    var buildCheckModelForRow = function (row) {
        var checkModel = {
            GUID: row.find('input.checkGUID').val(),
            Checked: row.find('input.checkChecked').is(':checked'),
            Unit: row.find('input.unitValue').val(),
            TextValue: row.find('input.textValue').val(),
            TextValue2: row.find('input.textValue2').val(),
            DateValue: row.find('input.dateValue').val(),
            DropDownValue: row.find('select.dropdownValue').find(':selected').val(),
            CheckedBy_UID: row.find('input.checkByUID').val(),
            Check_UID: row.find('input.checkUID').val(),
            CheckRemarks: row.find('textarea.checkremarkText').text(),
            FromProcedure_UID: row.find('input.checkFromProcedureUID').val(),
            FromOrderProcedure_UID: row.find('input.checkFromOrderProcedureUID').val(),
            FromProcedure_Color: row.find('input.checkFromProcedureColor').val(),
            FromProcedure_Code: row.find('input.checkFromProcedureCode').val(),
            FromProcedure_Modality: row.find('input.checkFromProcedureModality').val(),
            IsGrouped: row.find('input.isGrouped').val(),
            IsGroupMaster: row.find('input.isGroupMaster').val(),
            IsGroupSlave: row.find('input.isGroupSlave').val(),
            Room_UID: row.find('input.roomUID').val(),
            Room_Text: row.find('input.roomText').val()
        };

        return checkModel;
    }

    if (Model.Validated || Model.ReadOnly) {
        $('input#btnExportPDF').on('click', function (e) {
            $('#dialogDecision' + viewbagUniquePrefix + ' span.validation').html('');
            $('#dialogDecision' + viewbagUniquePrefix + ' span.validation').hide();
            $('#dialogDecision' + viewbagUniquePrefix + ' #txtFrom').val(Model.GeneralEmailFromAddress);
            $('#dialogDecision' + viewbagUniquePrefix + ' #txtTo').val(Model.ApplicantPrivateEmailAddress);

            $('#dialogDecision' + viewbagUniquePrefix + ' #txtContent').html(window.Resources.OrderReport + ' - #' + Model.OrderNumber + ' ' + Model.PatientName);
            $('#dialogDecision' + viewbagUniquePrefix + ' #txtSubject').val($('#dialogDecision' + viewbagUniquePrefix + ' #txtContent').html());

            $('#dialogDecision' + viewbagUniquePrefix).dialog('open');
            $('#dialogDecision' + viewbagUniquePrefix + ' #txtTo').focus();
            $('#dialogDecision' + viewbagUniquePrefix).dialog('open');
        });

        $('#dialogDecision' + viewbagUniquePrefix + ' #btnDownload').on('click', function (e) {
            $('#dialogDecision' + viewbagUniquePrefix).dialog('close');
            window.open('/legacy/Reports/PdfExportValidatedReport?OrderID=' + Model.OrderID);
        });

        $('#dialogDecision' + viewbagUniquePrefix + ' #btnSend').on('click', function (e) {
            var from = $('#dialogDecision' + viewbagUniquePrefix + ' #txtFrom').val();
            var to = $('#dialogDecision' + viewbagUniquePrefix + ' #txtTo').val();
            var subject = $('#dialogDecision' + viewbagUniquePrefix + ' #txtSubject').val();
            var content = $('#dialogDecision' + viewbagUniquePrefix + ' #txtContent').val();

            var filter=/\S+@\S+\.\S+/;
            if (filter.test(to)) //good email
            {
                $.ajax({
                    type: 'POST',
                    url: '/legacy/Reports/EmailPdfExportValidatedReport',
                    data: {
                        OrderID: Model.OrderID,
                        Report_UID: null,
                        From: from,
                        To: to,
                        Subject: subject,
                        Content: content
                    },
                    dataType: 'json',
                    async: false,
                    success:
                        function (data) {
                            if (data.Error) {
                                $('#dialogDecision' + viewbagUniquePrefix + ' span.validation').html(htmlDecode(window.ErrorStrings.ErrorOccured));
                                $('#dialogDecision' + viewbagUniquePrefix + ' span.validation').show();
                                console.log(data.ErrorMessage);
                            }
                            else {
                                $('#dialogDecision' + viewbagUniquePrefix).dialog('close');
                            }
                        }
                });
            }
            else {
                $('#dialogDecision' + viewbagUniquePrefix + ' span.validation').html(htmlDecode(window.ErrorStrings.ErrorValidEmail));
                $('#dialogDecision' + viewbagUniquePrefix + ' span.validation').show();
            }
        });

        $('input#printReport').on('click', function (e) {
            $.ajax({
                type: 'POST',
                data: { OrderID: Model.OrderID },
                url: '/legacy/Reports/PrintReport',
                dataType: 'json',
                success: function (data) {
                    if (data.AllOk != true) {
                        alert("Printing failed");
                    }
                }
            });
        });

        $('li#openPreviewTab a').trigger('click');

        $('#btnOKDevalidateScreening' + viewbagUniquePrefix).on('click', function () {
            invalidateRequest();
            $('#divDevalidateScreening').dialog('close');
        });

        $('#btnNOKDevalidateScreening' + viewbagUniquePrefix).on('click', function () {
            $('#divDevalidateScreening').dialog('close');
        });

        var invalidateRequest = function () {
            $.ajax({
                type: 'POST',
                url: '/legacy/Reports/InvalidateFullReport',
                data: { Report_UID: Model.FullOrderReport_UID },
                async: false,
                dataType: 'json',
                success: function (data) {
                    ReportSharedFunctions.LaunchEmptyPacsIntegration();
                    closeActiveFile(false, true).done(function() {
                        $.ajax({
                            type: 'POST',
                            url: '/legacy/Locks/TryCreateLockFile',
                            data: {
                                LockType: LockType.OrderReport,
                                RecordID: $('#lockableRecordID').text(),
                                Detail: true
                            },
                            async: false,
                            dataType: 'json',
                            success:
                                function (data) {
                                    if (data.Done) {
                                        window.addLocks(new URLSearchParams(window.location.search).get('fc') * 1, data.LockUIDs);
                                    }
                                    else if (!data.Done) {
                                        window.showLockedFileDialog(data, $('span#rawUrl').text());
                                    }
                                }
                        });
                    });
                }
            });
        }

        $('#btnInvalidateReport').on('click', function (e) {
            $.ajax({
                type: 'POST',
                url: '/legacy/Locks/CheckLockFileBeforeSaving',
                data: { LockType: LockType.OrderReport, RecordID: Model.OrderID },
                async: false,
                dataType: 'json',
                success:
                    function (data) {
                        if (data.Done) {
                            //check if screening
                            if (screening) {
                                //show popup with invalidatewarning
                                $('#divDevalidateScreening').dialog('open');
                            }
                            else {
                                //no screening, just invalidate
                                invalidateRequest();
                            }
                        }
                        else if (!data.Done) {
                            $('#divNotLockedDialog').dialog('open');
                        }
                    }
            });
        });
    }
    else
    {
        if(userHasSpeechRecognition)
        {
            function performEOLFunctionality(){
                if (EOLSaveOrValidate == 'None') {
                    //Do nothing
                }
                else if (EOLSaveOrValidate == 'Save') {
                    $('#btnSaveAndCloseFile').trigger('click', [true]);
                }
                else if (EOLSaveOrValidate == 'Validate') {
                    $('#btnValidateAndCloseFile').trigger('click', [true]);
                }
                else if (EOLSaveOrValidate == 'Transcribe') {
                    $('#btnSendToTranscription').trigger('click', [true]);
                }
                else if (EOLSaveOrValidate == 'Preliminary') {
                    $('#btnSendToPreliminary').trigger('click', [true]);
                }
            }

            if(useXintax)
            {
                $('#hasXintax').text("true");

                var firstSetupXintax = true;
                var pollXintaxTimeout;
                var firstSetupDate = "";
                try {
                    var launchXintax = function (e) {
                        launchSpeechXHR = $.ajax({
                            type: 'GET',
                            data: {
                                FirstSetup: firstSetupXintax,
                                OrderNumber: Model.OrderNumber,
                                FirstSetupDate: firstSetupDate
                            },
                            timeout: 15000,
                            url: '/legacy/Reports/LaunchXintaxOnClient',
                            success: function (data) {
                                firstSetupDate = data.FirstSetupDate;
                                if (firstSetupXintax) {
                                    $('#startSpeechRecognition').addClass('disabled');
                                    pollXintaxTimeout = setInterval(function (e) {
                                        launchXintax()
                                    }, 2000);
                                    timeouts.push(pollXintaxTimeout);
                                }
                                if (data.AllOk) {
                                    $('#startSpeechRecognition').removeClass('disabled');

                                    if (overWriteReportWithEmptyXintax) {
                                        tinymce.activeEditor.setContent(data.Text);
                                    }

                                    clearTimeout(pollXintaxTimeout);

                                    performEOLFunctionality();
                                }
                                else if (data.Error) {
                                    $('#startSpeechRecognition').removeClass('disabled');
                                    clearTimeout(pollXintaxTimeout);
                                }
                                firstSetupXintax = false;
                            },
                            error: function (data) {
                                $('#startSpeechRecognition').removeClass('disabled');
                                clearTimeout(pollXintaxTimeout);
                                launchSpeechXHR.abort();
                            }
                        });
                    }
                }
                catch (err) {
                    $('#startSpeechRecognition').removeClass('disabled');
                    launchSpeechXHR.abort();
                }

                $('#startSpeechRecognition').on('click', function (e) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    if (!$(this).hasClass('disabled')) {
                        firstSetupXintax = true;
                        launchXintax();
                    }
                });

                if(startSpeechRecognition && !Model.Screening)
                {
                    launchXintax();
                }
            }
            else
            {
                $('#subPageContent').on('click', '.btnCopyPreviousReportToG2', function (e) {
                    e.stopImmediatePropagation();
                    e.stopPropagation();
                    var text = $('#hiddenContent').val();
                    var guid = reportGUID;
                    $.ajax({
                        type: 'POST',
                        data: {
                            GUID: guid,
                            ReportContent: htmlEncode($.trim(text))
                        },
                        async: false,
                        url: '/legacy/Reports/CopyReportToG2Speech',
                        success: function (data) {
                        }
                    });
                });

                $('#hasG2Speech').text("true");

                $('#startSpeechRecognition').on('click', function (e) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    if (!$(this).hasClass('disabled')) {
                        $(this).addClass("disabled");
                        firstSetupG2 = true;
                        $("#editableContent").val("false");
                        launchG2Speech(true);
                    }
                });

                $('#getSpeechRecognitionText').on('click', function (e) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    e.stopPropagation();

                    $.ajax({
                        type: "GET",
                        url: "/legacy/Reports/GetG2SpeechDocumentOnSaveAndClose",
                        async: false,
                        data: {
                            GUID: reportGUID,
                            Order_UID: Model.OrderID
                        },
                        timeout: 15000,
                        success: function (data) {
                            if (data.AllOk) {
                                if (data.ReportGUID) {
                                    reportGUID = data.ReportGUID;
                                }
                                tinymce.activeEditor.setContent(data.Result);
                                clearTimeout(window.pollG2Timeout);
                                $('#startSpeechRecognition').removeClass('disabled');
                            }
                            else if (data.ErrorG2) {
                                alert(data.ErrorMessage);
                            }
                        }
                    });
                });

                $('#btnOkEditAndDeleteSpeechDocument').on('click', function (e) {
                    closeActiveSpeech(Model.OrderNumber).done(function (e) {
                        clearTimeout(window.pollG2Timeout);
                        if (typeof(launchSpeechXHR) !== "undefined") {
                            launchSpeechXHR.abort();
                        }

                        $('#editableContent').val("true");
                        //DELETE SPEECH DOCUMENT
                        $.ajax({
                            type: 'POST',
                            data: {
                                GUID: reportGUID,
                                Order_UID: Model.OrderID
                            },
                            async: false,
                            url: '/legacy/Reports/DeleteG2SpeechDocument',
                            success: function (data) {
                            }
                        });

                        $('#divEditAndDeleteSpeechDocument').dialog('close');
                        tinymce.activeEditor.focus();
                    });
                });

                setTimeout(() => { // Need some timeout to make sure ReportContent is filled in
                    const rc = document.getElementById('ReportContent').value;
                    const isNewReport = Model.ReportContent === '' && (rc === '' || rc === Model.DefaultReportTemplate);
                    if(startSpeechRecognition && !screening && (!isNewReport || !Model.MultipleAutoInsertOptions?.length))
                    {
                        if ($('#editableContent').val() == "false") {
                            launchG2Speech();
                        }
                    }
                }, 100);
            }
        }
    }

    if(openPACSIntegration && userHasPACSIntegration && openAllImages)
    {
        $('#showAllImagesLI').show();
    }

    if(openPACSIntegration && userHasPACSIntegration)
    {
        const numbers = Model.OrderProcedures.map(orderProcedure => orderProcedure.OrderHasProcedure_UID);
        ReportSharedFunctions.LaunchPacsIntegrationFor(numbers, multiple);
    }

    if(toShowScannedOrderOnReport)
    {
        $('li#openOrderDocumentTab a').trigger('click');
    }

    $(window).resize(function (e) {
        setTimeout(function () {
            ResizeOrderReportFields();
        }, 300);
    });

    setTimeout(function () {
        ResizeOrderReportFields();
    }, 300);

    var toValidate;
    var toClose;
    var toTranscription;
    var toPreliminary;
    var toTriggerExportFormats;

    function ShowPopupSetCurrentRadiologistAsSupervisor(validated, close, transcription, preliminary, triggerExportFormats) {
        toValidate = validated;
        toClose = close;
        toTranscription = transcription;
        toPreliminary = preliminary;
        toTriggerExportFormats = triggerExportFormats || false;

        $('#divSetCurrentRadiologistAsSupervisor').dialog('open');
    }

    var ShowPopupChooseSupervisor = function (validated, close, transcription, preliminary, triggerExportFormats) {
        toValidate = validated;
        toClose = close;
        toTranscription = transcription;
        toPreliminary = preliminary;
        toTriggerExportFormats = triggerExportFormats || false;

        $.ajax({
            type: "GET",
            url: "/legacy/Session/GetLastChosenSupervisors",
            async: false,
            success: function (data) {
                if (data.Supervisors.length > 0) {
                    $('#previousChosenSupervisors li.previousChosenSupervisor').remove();
                    for (var i = data.Supervisors.length - 1 ; i >= 0 ; i--) {
                        var li = '<li class="previousChosenSupervisor">- ' + data.Supervisors[i].Name + '<input type="hidden" class="previousChosenSupervisorID" value="' + data.Supervisors[i].ID + '" /></li>';
                        $('#previousChosenSupervisors').append(li);
                    }
                    $('#noPreviousChosenSupervisors').hide();
                }
                else {
                    $('#noPreviousChosenSupervisors').show();
                }
            }
        });

        $('#popupNewChoosenSupervisorID').val("");

        $('#btnChooseSupervisor').attr('disabled', true);

        $('#divChooseSupervisor').dialog('open');
    };

    $('#btnSetCurrentRadiologistAsSupervisorOk').on('click', function (e) {
        var selectedSupervisorID = userRadiologistId;
        $('#divSetCurrentRadiologistAsSupervisor').dialog('close');
        AddChosenSupervisorToSession(selectedSupervisorID);
    });

    $('#btnSetCurrentRadiologistAsSupervisorCancel').on('click', function (e) {
        var selectedSupervisorID = null;
        $('#divSetCurrentRadiologistAsSupervisor').dialog('close');
        ValidateOrSaveAndClose(toValidate, toClose, selectedSupervisorID, toTranscription, toPreliminary, toTriggerExportFormats);
    });

    $('#btnChooseSupervisor').on('click', function (e) {
        var newSupervisorID = $('#popupNewChoosenSupervisorID').val();
        var oldSupervisorID;
        var selectedSupervisorID;

        if (newSupervisorID) {
            selectedSupervisorID = newSupervisorID;
        }
        else {
            oldSupervisorID = $('.previousChosenSupervisor.active').find('.previousChosenSupervisorID').val();
            if (oldSupervisorID) {
                selectedSupervisorID = oldSupervisorID;
            }
        }

        if (selectedSupervisorID) {
            $('#divChooseSupervisor').dialog('close');
            AddChosenSupervisorToSession(selectedSupervisorID);
        }

    });

    function AddChosenSupervisorToSession(selectedSupervisorID) {
        $.ajax({
            type: "POST",
            url: "/legacy/Session/AddChosenSupervisorToSession",
            async: false,
            data: {
                Supervisor_UID: selectedSupervisorID
            },
            success: function (data) {
                ValidateOrSaveAndClose(toValidate, toClose, selectedSupervisorID, toTranscription, toPreliminary, toTriggerExportFormats);
            }
        });
    }

    $('body').on('click', 'li.previousChosenSupervisor', function (e) {
        e.stopImmediatePropagation();
        e.stopPropagation();
        $('li.previousChosenSupervisor').removeClass('active');
        $(this).addClass('active');
        $('#popupChooseSupervisor').val("");
        $('#popupNewChoosenSupervisorID').val("");
        $('#btnChooseSupervisor').prop('disabled', false);
    });

    if (Model.PossibilityToConfirmInvoiceInReport && (Model.InvoiceStatus == 0 || Model.InvoiceStatus == 1)) {
        var checkConfirmAndAdjustInvoice = function (e) {
            var confirmInvoice = $('#ConfirmInvoiceOnConfirmation').prop('checked');
            if (confirmInvoice) {
                $('#AdjustInvoiceOnConfirmNomenclatures').attr('disabled', false);
                $('#AdjustInvoiceOnConfirmNomenclatures').parent().show();
            }
            else {
                $('#AdjustInvoiceOnConfirmNomenclatures').attr('disabled', true);
                $('#AdjustInvoiceOnConfirmNomenclatures').parent().hide();
            }
        };

        $('#ConfirmInvoiceOnConfirmation').on('change', function (e) {
            checkConfirmAndAdjustInvoice();
        });

        checkConfirmAndAdjustInvoice();
    }

    $('ul.tabLinks li a').on('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();

        var href = $(this).attr('href');
        $('.tabLink').removeClass('active');
        $('.tabLink').addClass('passive');
        $(this).removeClass('passive');
        $(this).addClass('active');

        $('.tabHolder').removeClass('active');
        $('.tabHolder').addClass('passive');
        $(href).removeClass('passive');
        $(href).addClass('active');

        if ($(this).attr('id') == "openPreviewTab") {
            loadPreview();
        };
    });

    if ((Model.Validated || Model.ReadOnly) && !Model.Screening) {
        $('#loading').hide();
        $.ajax({
            type: "POST",
            url: '/legacy/Reports/GetReport',
            async: false,
            data: {
                Order_UID: Model.OrderID,
                ForOrder_Procedure_UID: null,
                Report_UID: Model.FullOrderReport_UID
            },
            success: function (data) {
                setTimeout(function () {
                    SetActiveReportsIFrame('validatedTab', Model.OrderID, htmlEncode(data.ReportContent), Model.FullOrderReport_UID, false);
                }, 10);
            }
        });
    }

    $('input#btnSendForReview').on('click', async function (e, fromEOL, dontCheckEmpty) {
        if (typeof dontCheckEmpty == "undefined") {
            dontCheckEmpty = false;
        }
        await ReportSharedFunctions.GetTextFromSpeechDocument();

        if (CheckReportContentBeforeSaving(dontCheckEmpty, 5)){
            $('#divChooseReviewer').dialog('open');
        }

    });
    
    $('#backToAuthor').on('click', async () => {
        await ReportSharedFunctions.GetTextFromSpeechDocument();
        GlobalValidateOrSaveAndClose(false, true, false, true, false, null);
    });
    
    window.onNavigateForRazor = async () => {
        window.clearRefreshTimeout();
        await window.closeActiveSpeechAsPromise();
    }
}
